// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Assets/fonts/Quicksand-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Assets/fonts/Quicksand-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../Assets/fonts/Quicksand-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../Assets/fonts/Quicksand-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../Assets/fonts/Quicksand-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../Assets/Store/FavouriteIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../Assets/OrderScreen/LoyaltyPointIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../Assets/Store/ReorderIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../Assets/Store/ScrollRight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../Assets/Store/HoverScrollRight.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../Assets/Store/ScrollLeft.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../Assets/Store/HoverScrollLeft.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../Assets/OrderScreen/LoyaltyPointBgCoins.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../Assets/OrderScreen/loyaltyPointBackground.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none !important;
}

@font-face {
  font-family: QuicksandLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: QuicksandBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: QuicksandMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: QuicksandRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: QuicksandSemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: QuicksandLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Start Single Store  */
.quickvee-single-store-top-bar {
  flex-wrap: wrap;
  z-index: 100;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  padding: 5px 20px;
  /* padding-left: 3%;
  padding-right: 3%; */
  background-color: #fff;
  border: 1px solid #ebebeb;
}
@media (max-width: 768px) {
  .quickvee-single-store-top-bar {
    padding: unset;
    padding-left: 3%;
    padding-right: 3%;
  }
}
.quickvee-single-store-top-bar > .quickvee-logo-icon-single-store {
  width: 250px;
}

.quickvee-single-store-offer-coupon {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  width: auto;
  position: relative;

  /* justify-content: center; */
}

.quickvee-single-store-offer-coupon > .quickvee-single-store-offer-button {
  width: 100%;
  background-color: #fff !important;
  padding: 6px 16px !important;
  color: #0a64f9;
  text-transform: uppercase;
  font-size: 16px;
  font-family: QuicksandBold !important;
  transition: all 0.4s ease-in-out;
}

.quickvee-single-store-offer-coupon
  > .quickvee-single-store-offer-button
  > span {
  color: #232323;
  text-transform: uppercase;
  font-size: 16px;
  font-family: QuicksandBold !important;
}

.quickvee-single-store-offer-coupon
  > .quickvee-single-store-offer-button:hover {
  box-shadow: 0px 6px 12px #00000029;
}

.quickvee-single-store-offer-coupon > .quickvee-single-store-offer-detail {
  position: absolute;
  margin-top: 40px;
  /* width: 230px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 6px 12px #00000029;
  padding: 10px 0;
  border-radius: 0px 0px 6px 6px;
  border-top: 1px solid #ebebeb;
  background-color: #fff;
  animation: fadeIncoupon 0.3s linear;
  left: 0;
  right: 0;
}

@keyframes fadeIncoupon {
  0% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
  }
}

.quickvee-single-store-offer-coupon
  > .quickvee-single-store-offer-detail
  > .usecoupon-text {
  color: #202020;
  text-transform: capitalize;
  font-size: 16px;
  font-family: QuicksandBold !important;
  margin: 5px 0;
}

.quickvee-single-store-offer-coupon
  > .quickvee-single-store-offer-detail
  > .coupon-copytext {
  margin: 14px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 6px 2px 26px;
  background: #f1f6ff;
  color: #0a64f9;
  text-transform: uppercase;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.quickvee-single-store-offer-coupon
  > .quickvee-single-store-offer-detail
  > span {
  color: #5d5d5d;
  font-size: 9px;
  font-family: QuicksandSemiBold;
  margin: 2px 0;
}

.quickvee-single-store-top-bar
  > .quickvee-single-store-login-and-wishlist-button {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quickvee-customer-login-main {
  position: relative;
}

.quickvee-customer-login {
  background: #0a64f9 !important;
  border-radius: 6px;
  color: #ffffff;
  font-size: 16px !important;
  /* font-family: QuicksandBold !important; */
  text-transform: capitalize;
  padding: 10px 16px;
  margin: 0 5px;
  cursor: pointer;
  text-decoration: none;
  height: 44px;
  text-align: center;
  min-width: 76px;
}

.quickvee-single-store-top-bar
  > .quickvee-single-store-login-and-wishlist-button
  > .quickvee-single-store-cart-button {
  cursor: pointer;
  background: #f6f7f8 !important;
  border-radius: 6px !important;
  padding: 6px 20px !important;
  margin: 0 5px;
  line-height: normal !important;
  color: #232323;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.quickvee-single-store-main-area {
  display: flex;
  /* overflow: hidden; */
}

.quickvee-single-store-left-menu {
  background: #fff;
  position: fixed;
  left: 0;
  width: 250px;
  border-right: 1px solid #ebebeb;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 10px 0;
  display: block;
  scroll-behavior: smooth;
}

.quickvee-single-store-left-menu::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.quickvee-single-store-left-menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.quickvee-single-store-left-menu::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.quickvee-single-store-left-menu::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.quickvee-single-store-left-menu > .quickvee-left-menu-single-store-detail {
  background-color: #fff;
  /* margin: 10px 0 0 0; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* position: sticky;
  width: 100%;
  right: 0;
  top: 0;
  left: 0; */
  padding: 0px 15px 0px 15px;
}

.quickvee-single-store-logo {
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10px 10px 0;
  position: sticky;
  top: 0;
  z-index: 25;
}

.quickvee-single-store-logo a img {
  object-fit: contain;
  object-position: center;
  border-radius: 100px;
  border: 2px solid #f2f2f2;
  overflow: hidden;
  text-align: center;
  padding: 10px;
  position: relative;
  width: 100px;
  height: 100px;
  left: 0px;
  top: 0px;
  transition: all 0.5s;
}

.quickvee-single-store-logo.scrolled a img {
  position: relative;
  width: 50px;
  height: 50px;
  left: -83px;
  top: 0px;
}

.quickvee-single-store-logo > span {
  border-radius: 12px;
  color: #fff;
  font-family: QuicksandMedium !important;
  text-transform: uppercase;
  padding: 2px 10px;
  font-size: 13px;
  margin-top: -12px;
  z-index: 1;
}

.quickvee-left-menu-single-store-detail-sticky {
  height: 100%;
  transition: all 0.5s;
}

.quickvee-left-menu-single-store-detail-sticky.scrolled {
  height: 5px;
}

.quickvee-left-menu-single-store-detail-sticky
  > .quickvee-single-store-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 0px 10px;
  position: relative;
  top: 0px;
  right: 0px;
  transition: all 0.5s;
}

.quickvee-left-menu-single-store-detail-sticky
  > .quickvee-single-store-content.scrolled {
  top: -50px;
  right: -31px;
  padding: 0px;
}

.quickvee-left-menu-single-store-detail-sticky
  > .quickvee-single-store-content
  > p {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: #2e2e2e;
  text-transform: capitalize;
  font-size: 12px;
  font-family: QuicksandSemibold !important;
  text-align: center;
  margin: 5px 0;
  position: relative;
  right: 0px;
  transition: all 0.5s;
}

/* .quickvee-left-menu-single-store-detail-sticky >.quickvee-single-store-content>p.scrolled{
  right: -19px; 
} */

.quickvee-left-menu-single-store-detail-sticky
  > .quickvee-single-store-content
  > span {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #232323;
  text-transform: capitalize;
  font-size: 16px;
  text-align: center;
  font-family: QuicksandBold !important;
}

.quickvee-left-menu-single-store-detail > .quickvee-single-store-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.quickvee-left-menu-single-store-detail > .quickvee-single-store-content > p {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: #2e2e2e;
  text-transform: capitalize;
  font-size: 12px;
  font-family: QuicksandSemibold !important;
  text-align: center;
}

.quickvee-left-menu-single-store-detail
  > .quickvee-single-store-content
  > span {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #232323;
  text-transform: capitalize;
  font-size: 16px;
  font-family: QuicksandBold !important;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-detail
  > .quickvee-single-store-pickup-delivery {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  background: #efefef;
  border-radius: 5px;
  padding: 5px 10px;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-detail
  > .quickvee-single-store-pickup-delivery
  > Button {
  width: 100%;
  padding: 3px 25px;
  background-color: none;
  color: #928c8c;
  font-size: 15px;
  text-transform: capitalize !important;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-detail
  > .quickvee-single-store-pickup-delivery
  > Button {
  width: 100%;
  padding: 3px 25px;
  background-color: #efefef;
  color: #928c8c;
  font-size: 15px;
  text-transform: capitalize !important;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-detail
  > .quickvee-single-store-pickup-delivery
  > .active-delivery-button {
  background: #000;
  color: #ffffff;
  font-size: 15px;
  font-family: QuicksandMedium !important;
  box-shadow: 0px 6px 12px #00000042;
}

.quickvee-single-store-reorder-wishlist {
  margin: 5px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.loading-category-menu-listing-elements {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link {
  width: 98%;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  margin: 2px 0;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link-active {
  background: #ffffff !important;
  box-shadow: 0px 6px 16px #0a64f936;
  border: 1px solid #0a64f9;
  border-radius: 5px;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link-active
  > .wishlist-icon {
  background: #0a64f9 !important;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 0px;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link-active
  > .loyaltyIcon-icon {
  background: #0a64f9 !important;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0px;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link-active
  > span {
  color: #0a64f9 !important;
}

.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link:hover {
  background: #f1f6ff;
  border-radius: 5px;
}

.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link > span {
  color: #2e2e2e;
  font-size: 16px;
  font-family: QuicksandSemiBold !important;
  transition: all 0.2s ease-in-out;
  margin-left: 12px;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link:hover
  > span {
  color: #6e81e2;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link
  > .wishlist-icon {
  background: #2e2e2e;
  width: 20px;
  height: 20px;
  display: inline-block;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 0px;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link:hover
  > .wishlist-icon {
  background: #6e81e2;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 0px;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link
  > .loyaltyIcon-icon {
  background: #2e2e2e;
  width: 20px;
  height: 20px;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0px;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link:hover
  > .loyaltyIcon-icon {
  background: #6e81e2;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 0px;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link
  > .reorder-icon {
  background: #2e2e2e;
  width: 20px;
  height: 20px;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat 0px;
  transition: all 0.2s ease-in-out;
}

.quickvee-single-store-reorder-wishlist
  > .quickvee-single-store-link:hover
  > .reorder-icon {
  background: #6e81e2;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat 0px;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-navigations {
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: block;
}

.quickvee-left-menu-single-store-navigations::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.quickvee-left-menu-single-store-navigations::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.quickvee-left-menu-single-store-navigations::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.quickvee-left-menu-single-store-navigations::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-navigations
  > .single-store-all-products {
  font-size: 16px !important;
  font-family: QuicksandBold !important;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-navigations
  > .single-store-product-active {
  background: #f5f5f5;
  border-left: 5px solid #232323;
  font-size: 14px;
  font-family: QuicksandBold !important;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-navigations
  > a {
  width: 100%;
  text-decoration: none;
  color: #2e2e2e;
  font-family: QuicksandSemiBold !important;
  font-size: 14px;
  padding: 10px 0 10px 20px;
  border-left: 5px solid transparent;
  transition: all 0.2s ease-in-out;
  display: inline-block;
}

.quickvee-single-store-left-menu
  > .quickvee-left-menu-single-store-navigations
  .single-store-all-products-active {
  background: #f5f5f5;
  border-left: 5px solid #232323 !important;
  font-family: QuicksandBold !important;
  padding: 13px 10px 10px 20px;
}

.quickvee-single-store-main-area-detail-page {
  margin-left: 15%;
  width: calc(100% - 15%);
  display: flex;
  padding: 10px 20px 0px 20px !important;
  overflow-x: hidden;
}

/* View Full Hours */

.view-full-hour-link {
  text-decoration: underline !important;
  color: #3f882b !important;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #232323;
  text-transform: capitalize;
  font-size: 16px;
  font-family: QuicksandBold !important;
}

.modal-view-full-hours-div:focus-visible {
  outline: none !important;
}

.modal-view-full-hours-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  box-sizing: border-box;
}

#modal-view-full-hours-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  margin-bottom: 8px;
  box-sizing: border-box;
  border-bottom: 2px solid #0000001a;
}

#modal-view-full-hours-header > span {
  /* margin: 0 auto; */
  font-weight: 600;
  color: #2d2a6e;
  font-size: 26px;
  justify-self: center;
  font-family: Jost;
}

.modal-view-full-hours-close {
  padding: 5px;
  display: inline-grid;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}

.modal-view-full-hours-close:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.22);
  outline-offset: 2px;
}

.modal-view-full-hours-description {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal-view-full-hours-description > .full-hours-data {
  width: 100%;
  overflow-x: hidden;
  /* padding: 20px; */
  box-sizing: border-box;
}

.modal-view-full-hours-description > .full-hours-data > div {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: auto;
  padding: 10px 0;
}

.modal-view-full-hours-description > .full-hours-data .view-hour-today p {
  /* box-shadow: 0px 0px 7px #005df0; */
  /* margin: 3px -3px;
  border-radius: 5px;
  width: 102%; */
  font-size: 18px;
  font-weight: 600;
  font-family: Jost !important;
  color: #0a64f9;
  white-space: nowrap;
}

.modal-view-full-hours-description > .full-hours-data .view-hour-today-span {
  width: 104px;
}

.modal-view-full-hours-description .full-hours-data .single-time-slot {
  width: 48%;
}

.modal-view-full-hours-description > .full-hours-data > div:nth-child(odd) {
  /* background: #f9f9f9; */
  display: flex;
  align-items: start;
  justify-content: space-between;
}

.modal-view-full-hours-description > .full-hours-data > div > span {
  text-transform: capitalize;
  width: 100px;
  text-align: center;
  color: #232323;
  font-size: 16px;
  font-family: QuicksandBold !important;
  /* border-right: 2px solid #c7c7c7; */
}

.modal-view-full-hours-description > .full-hours-data > div > p {
  color: #000000;
  font-size: 18px;
  font-family: jost !important;
  font-weight: 400;
  text-align: center;
}

.modal-view-full-hours-description > .full-hours-data > div > p > span {
  display: flex;
  flex-wrap: wrap;
}

.modal-view-full-hours-description
  > .full-hours-data
  > div
  > p
  > span.active-day-hour {
  display: inline-block !important;
  font-size: 14px;
}

.modal-view-full-hours-description > .full-hours-data-detail {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding-top: 15px;
  margin-top: 10px;
  width: 100%;
  border-top: 2px solid #0000001a;
}

.modal-view-full-hours-description
  > .full-hours-data-detail
  > .single-full-hour-data-detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: center; */
  /* padding: 20px; */
  width: 100%;
}

.full-hours-data-detail > .single-full-hour-data-detail > img {
  margin-bottom: 15px;
  width: 60px;
  height: 60px;
}

.full-hours-data-detail > .single-full-hour-data-detail > p {
  color: #232323;
  font-size: 18px !important;
  /* font-family: QuicksandBold !important; */
  margin-left: 14px;
  font-weight: 600;
  font-family: Jost;
}

.full-hours-data-detail > .single-full-hour-data-detail > p > span {
  color: #000000;
  font-size: 18px !important;
  /* font-family: QuicksandBold !important; */
  line-height: 20px;
  font-weight: 400;
}

/* end full hours modal*/
/* End Single Store  */

/* Start Store Wishlist */
.quickvee-store-topbar-cart {
  width: 450px;
  background: #ffffff;
}

.quickvee-store-topbar-cart > .quickvee-store-cart-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.quickvee-store-topbar-cart > .quickvee-store-cart-header > h1 {
  font-size: 24px;
  font-family: QuicksandBold !important;
  color: #222222;
  text-align: center;
  margin-bottom: 0;
}

.quickvee-store-topbar-cart > .quickvee-store-cart-header > h1 > span {
  font-size: 18px;
  color: #595959;
}

.quickvee-store-topbar-cart > .quickvee-store-cart-header > Button {
  padding: 5px !important;
  background: #f3f3f3 !important;
  min-width: 50px !important;
}

.quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn {
  display: flex;
  justify-content: center;
  align-self: center;
  position: absolute;
  bottom: 0;
  margin-bottom: 10px;
  width: 100%;
  padding: 0px 20px 0px 20px;
}

.delivery-amount-modal-cart .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  padding: 55px;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.not-select-empty-delivery-content h1 {
  font-family: QuicksandSemiBold !important;
  font-size: 19px;
  color: #232323;
  margin-top: 15px;
}

.delivery-address-not-selected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 20px;
}

.delivery-amount-button-cart-ok {
  margin-top: 10px;
  align-self: center;
  text-decoration: none;
  text-align: center;
  width: 150px;
  background: #0a64f9;
  padding: 10px 0;
  border-radius: 6px;
  color: #ffffff;
  font-family: QuicksandBold !important;
  font-size: 16px;
  text-transform: capitalize !important;
  cursor: pointer;
  outline: none;
  border: 1px solid #0a64f9;
  margin: 20px;
}

.delivery-amount-modal-cart-text {
  font-family: QuicksandBold !important;
  font-size: 20px;
  text-align: center;
}

.quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > a,
.quickvee-store-topbar-cart
  > .quickvee-store-cart-checkout-btn
  > .payment-checkout-with-login,
.quickvee-store-cart-checkout-btn .button-for-minamount-on-delivery {
  text-decoration: none;
  text-align: center;
  width: 100%;
  background: #000000;
  padding: 13px 0px !important;
  border-radius: 6px;
  color: #ffffff;
  font-family: QuicksandBold !important;
  font-size: 16px;
  text-transform: capitalize !important;
  line-height: 1;
  letter-spacing: normal;
  height: 44px;
}

.quickvee-store-cart-checkout-btn .button-for-minamount-on-delivery:hover {
  background: #0a64f9;
}

.quickvee-store-cart-items {
  overflow-y: auto;
  scroll-behavior: smooth;
  /* margin: 10px 0; */
  width: 100%;
  height: 87vh;
}

/* width */
.quickvee-store-cart-items::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.quickvee-store-cart-items::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.quickvee-store-cart-items::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.quickvee-store-cart-items::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.quickvee-store-cart-items > .quickvee-store-cart-single-item {
  padding: 17px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  border-top: 1px solid #e1e1e1;
  position: relative;
}

.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-image {
  border: 1px solid #e1e1e1;
  padding: 10px;
  height: 80px;
}

.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-image {
  object-fit: contain;
}

.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-content {
  width: 310px;
  padding: 0px 10px 0px 17px;
}

.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-content
  > .q-cart-product-name {
  width: 85%;
  display: flex;
  color: #212121;
  font-size: 15px;
  font-family: QuicksandMedium !important;
  margin-bottom: 10px;
  text-transform: capitalize !important;
}

.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-content
  > p {
  color: #232323;
  font-family: QuicksandBold !important;
  font-size: 12px;
  margin: 5px 0;
}

.quickvee-store-cart-items
  > .quickvee-store-cart-single-item
  > .quickvee-scsi-content
  > p
  > span {
  color: #707070;
  margin: 0 2px;
}

.q-cart-product-amount-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 0;
}

.q-cart-product-amount-section > .q-cart-product-amount-calculation > span {
  color: #2e2e2e;
  font-family: QuicksandBold !important;
  font-size: 20px;
  margin: 0 4px;
}

.q-cart-product-amount-section > .q-cart-product-amount-calculation > del {
  color: #989898;
  font-family: QuicksandMedium !important;
  font-size: 14px;
  margin: 0 4px;
}

.q-cart-product-amount-update {
  display: flex;
  align-items: center;
}

.q-cart-product-amount-section > .q-cart-product-amount-update > button {
  color: #fff;
  background: #0a64f9;
  border-radius: 4px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 6px 16px 6px;
  cursor: pointer;
}

.q-cart-product-amount-section
  > .q-cart-product-amount-update
  > button:disabled {
  opacity: 0.5;
}

.q-cart-product-amount-section > .q-cart-product-amount-update > span {
  color: #000000;
  font-family: QuicksandSemibold !important;
  font-size: 19px;
  margin: 0 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quickvee-scsi-content > .q-cart-product-customize {
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 13px 0;
  position: absolute;
  top: 0px;
  right: 15px;
}

.quickvee-scsi-content > .q-cart-product-customize > span {
  color: #595959;
  font-family: QuicksandBold !important;
  font-size: 16px;
  border-right: 2px solid #595959;
  padding-right: 15px;
  cursor: pointer;
}

.quickvee-scsi-content > .q-cart-product-customize > img {
  padding-left: 15px;
  cursor: pointer;
}

.single-store-empty-cart {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 80vh;
}

.empty-cart-content {
  /* width: 250px; */
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-cart-content img {
  width: 80px;
  margin-bottom: 20px;
}

.empty-cart-content h1 {
  font-family: QuicksandSemiBold !important;
  font-size: 19px;
  color: #232323;
}

.empty-cart-content p {
  font-family: QuicksandSemiBold !important;
  font-size: 13px;
  color: #878787;
  margin: 15px auto;
}

.empty-cart-content .continue-shopping-on-cart {
  color: #0a64f9;
  width: 200px;
  border: 2px solid #0a64f9;
  background: #fff;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  text-transform: capitalize !important;
  background: #ffffff;
  border-radius: 5px;
  margin-top: 30px;
}

.continue-shopping-on-cart:hover {
  background: #fff !important;
}

.continue-shopping-on-cart a {
  text-decoration: none;
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
}

/* End Store cart*/

/*  start single product page */
.quickvee-single-product-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
}

.quickvee-single-product-top-section {
  display: flex;
  width: 100%;
}

.quickvee-single-product-image-section {
  display: flex;
  flex-direction: column;
  margin: 20px;
  width: 45%;
  position: sticky;
  top: 0;
}

.quickvee-single-product-image-section > .quickvee-single-product-main-image {
  position: relative;
  border: 1px solid #e1e1e1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

@media (max-width: 768px) {
  .quickvee-single-product-image-section > .quickvee-single-product-main-image {
    height: unset;
  }
  .quickvee-single-product-main-image {
    width: 100%;
  }
  .quickvee-single-product-main-image-skeleton {
    width: 320px !important;
  }
}

.quickvee-single-product-images {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 15px 0;
}

.quickvee-single-product-images .skeleton-for-loading {
  display: flex;
  margin-left: 10px;
}

.quickvee-single-product-images > .quickvee-single-product-images-single-image {
  border: 1px solid #e1e1e1;
  padding: 5px 10px;
  margin: 0 9px 10px 0;
  transition: all 0.5s ease-in-out;
  cursor: pointer;
}

.quickvee-single-product-images
  > .quickvee-single-product-images-single-image
  > img {
  width: 68px;
}

.quickvee-single-product-images
  > .quickvee-single-product-images-single-image:hover {
  border: 1px solid #232323;
}

.quickvee-single-product-image-section
  > .quickvee-single-product-main-image
  > span {
  position: absolute;
  top: 0;
  left: 0;
  /* background: #373737; */
  padding: 10px 10px !important;
  font-size: 17px;
  font-family: QuicksandBold !important;
  color: #ffffff;
  align-self: flex-start;
}

.quickvee-single-product-image-section
  > .quickvee-single-product-main-image
  > .quickvee-single-product-add-to-wishlist-icon {
  background: #efefef;
  padding: 10px;
  align-self: flex-start;
  margin: 6px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.quickvee-single-product-image-section
  > .quickvee-single-product-main-image
  > .quickvee-single-product-div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.quickvee-single-product-div img {
  object-fit: cover;
  object-position: center;
  width: 90%;
  height: 90%;
}

/* .quickvee-single-product-div  img:hover{

} */
.quickvee-single-product-detail-section {
  width: 62%;
  display: flex;
  flex-direction: column;
  margin: 20px;
}

.quickvee-single-product-detail-section::-webkit-scrollbar {
  width: 0px;
}

.quickvee-single-product-detail-section > .quickvee-single-product-main-detail {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.quickvee-single-product-detail-section
  > .quickvee-single-product-main-detail
  > h1 {
  color: #212121;
  font-size: 22px;
  font-family: QuicksandLight !important;
}

.quickvee-single-product-detail-section
  > .quickvee-single-product-main-detail
  > p
  > span {
  color: #2e2e2e;
  font-size: 24px;
  font-family: QuicksandBold !important;
}

p.bogo-discount {
  font-size: 15px;
  font-family: QuicksandMedium !important;
  margin: 8px 0px;
}

.quickvee-single-product-detail-section
  > .quickvee-single-product-main-detail
  > p
  > del {
  color: #989898;
  font-size: 16px;
  font-family: QuicksandMedium !important;
}

.quickvee-single-product-detail-section > .quickvee-single-product-features {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.quickvee-single-product-single-features {
  margin: 5px 0;
}

.quickvee-single-product-single-features > p {
  display: flex;
  color: #232323;
  font-size: 16px;
  font-family: QuicksandBold !important;
}

.single-product-single-features-selection {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 0 12px 0;
}

.single-product-single-features-selection > div > input {
  visibility: hidden;
  width: 0px;
  height: 45px;
}

.single-product-single-features-selection > div > input:checked + label {
  color: #0a64f9;
  background: #ffffff;
  box-shadow: 0px 0px 9px #0a64f94d;
  border: 1px solid #176cf8;
  border-radius: 4px;
  height: 44px;
}

.single-product-single-features-selection > div > label {
  cursor: pointer;
  color: #434343;
  text-transform: capitalize;
  font-size: 14px;
  font-family: QuicksandSemibold !important;
  background: #efefef 0% 0% no-repeat padding-box;
  border-radius: 4px;
  padding: 10px 14px;
  margin: 8px 15px 8px 0;
  border: 1px solid #efefef00;
  height: 44px;
}

.quickvee-single-product-add-update {
  display: flex;
  margin: 20px 0;
}

.quickvee-single-product-add-update > button {
  background: #0a64f9;
  border-radius: 4px;
  color: #fff;
  padding: 0px 8px !important;
  border: none;
  cursor: pointer;
  height: 44px;
}

.quickvee-single-product-add-update .add-minuus-button {
  display: flex;
  padding: 12px !important;
}

/* .quickvee-single-product-add-update .add-minuus-button img{
  width: 20px;
} */
.quickvee-single-product-add-update > button:disabled {
  opacity: 0.5;
  cursor: auto;
}

.quickvee-single-product-add-update > span {
  margin: 5px 15px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: QuicksandSemiBold !important;
  font-size: 20px;
}

.quickvee-single-product-add-update > .single-patc-btn,
.quickvee-single-product-add-update > .single-patc-btn:hover {
  background: #232323;
  border-radius: 4px;
  color: #ffffff;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
  padding: 5px 20px !important;
  text-transform: capitalize !important;
  margin: 0 20px;
}

.quickvee-single-product-add-update > .single-patc-btn:disabled {
  color: #fff;
  cursor: not-allowed;
  pointer-events: all;
}

.go-to-cart-btn,
.go-to-cart-btn:hover {
  width: 50%;
  background: #232323 !important;
  border-radius: 4px !important;
  color: #ffffff !important;
  font-family: QuicksandSemiBold !important;
  font-size: 14px !important;
  padding: 7.76px 20px !important;
  text-transform: capitalize !important;
  margin: 20px 0 !important;
  height: 44px;
}

.quickvee-single-product-detail-description > span {
  color: #232323;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.quickvee-single-product-detail-description > p {
  margin: 10px 0;
  font-family: QuicksandMedium !important;
  text-align: justify;
}

.quickvee-single-product-detail-description > ul {
  padding: 0 20px;
  font-family: QuicksandMedium !important;
  text-align: justify;
}

.quickvee-single-product-detail-description > ul > li {
  list-style: none;
}

.quickvee-single-product-detail-description > ul li::before {
  content: '\\2022';
  color: #232323;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.quickvee-single-product-bottom-section {
  margin: 0 0 20px 0;
}

.quickvee-single-product-bottom-section > span {
  color: #232323;
  font-size: 20px;
  font-family: QuicksandBold !important;
}

.quickvee-single-product-bottom-content-section {
  border: 1px solid #dcdcdc;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: flex-start;
  margin: 10px 0;
}

.fbt-products {
  display: flex;
  padding: 20px;
  align-items: center;
}

.fbt-single-product-div {
  width: 100%;
}

.fbt-single-product-div
  > .fbt-single-product
  > .fbt-single-product-content
  > span {
  color: #212121;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  margin-bottom: 5px;
}

.fbt-single-product-div
  > .fbt-single-product
  > .fbt-single-product-content
  > p {
  color: #2e2e2e;
  font-size: 17px;
  font-family: QuicksandBold !important;
}

.fbt-single-product-div
  > .fbt-single-product
  > .fbt-single-product-content
  > p
  > del {
  color: #989898;
  font-size: 13px;
  font-family: QuicksandMedium !important;
}

.fbt-single-product-div > .fbt-single-product {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #2ccb61;
}

.fbt-single-product-div > .fbt-single-product > .fbt-single-product-content {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 10px;
  width: 80%;
}

.quickvee-single-product-bottom-content-section
  > .fbt-products
  > .fbt-single-product-div {
  display: flex;
  flex-direction: column;
}

.fbt-category-selected-items > div {
  font-size: 14px !important;
  text-transform: capitalize !important;
}

.fbt-category-selected-items
  .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {
  padding: 20px 10px 3px 9px !important;
}

.fbt-category-item {
  font-size: 14px !important;
}

.fbt-category-label > label {
  color: #232323 !important;
  font-size: 14px !important;
  font-family: QuicksandSemiBold !important;
}

.quickvee-single-product-bottom-content-section > .fbt-products-amount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9f9f9;
  padding: 5px 10px;
}

.fbt-products-plus-product-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 34%;
}

.fbt-single-product-div > .fbt-single-product-features > div {
  margin: 10px 0;
}

.quickvee-single-product-bottom-content-section > .fbt-products-amount > p {
  font-family: QuicksandRegular !important;
  font-size: 20px;
}

.quickvee-single-product-bottom-content-section
  > .fbt-products-amount
  > Button {
  background: #0a64f9 !important;
  border-radius: 4px;
  font-size: 15px;
  font-family: QuicksandSemiBold !important;
  text-transform: capitalize;
  color: #fff;
  padding: 4px 13px !important;
}

.quickvee-highest-selling-product-section {
  width: 100%;
  height: auto;
  display: inline-block;
}

.quickvee-highest-selling-product-section > span {
  color: #232323;
  font-size: 20px;
  font-family: QuicksandBold !important;
  line-height: 55px;
}

.quickvee-highest-selling-products {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 15px 0;
}

/*  end  single product page */

/* start Single Product */

.q-sv-single-product {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 300px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 10px;
  transition: all 0.4s ease-in-out;
  /* margin: 0px 30px 25px 0px; */
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
}

.slick-slider {
  margin: 0 -15px;
}

.slick-initialized .slick-slide {
  padding-right: 20px;
  padding-left: 20px;
}

@media (min-width: 1024px) {
  .q-sv-single-product:hover {
    box-shadow: 0px 8px 22px #00000017;
    border: 1px solid #c6c6c6;
    border-radius: 5px;

    /* height: 290px; */
  }
}

.q-sv-single-product > .q-sv-single-product-top {
  outline: none;
  width: 200px;
  height: 150px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* margin-bottom: 20px; */
  align-self: center;
}

.discout-tag {
  z-index: 2;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 28px;
  border-radius: 4px 0px;
  color: #ffffff;
  font-size: 14px;
  font-family: QuicksandBold !important;
  padding: 5px 10px;
  align-self: flex-start;
}

span.limited-qty-text {
  color: red;
  z-index: 2;
  position: absolute;
  top: 6px;
  right: 10px;
  font-size: 14px;
  font-family: QuicksandBold !important;
  width: auto !important;
}

span.limited-quantity-text {
  color: red;
  font-size: 16px;
  font-family: QuicksandBold !important;
  width: auto !important;
}

@media (min-width: 768px) {
  .discout-tag-mobile {
    display: none;
  }
}
@media (max-width: 768px) {
  .discout-tag {
    display: none;
  }
  span.limited-qty-text {
    margin-bottom: 6px;
  }
}
.discout-tag-mobile {
  z-index: 2;
  /* position: absolute; */
  /* top: 0px;
  left: 0px; */
  /* height: 18px; */
  border-radius: 0px;
  color: #ffffff;
  font-size: 12px;
  font-family: QuicksandBold !important;
  padding: 2px 7px;
  align-self: flex-start;
}
.q-sv-single-product > .q-sv-single-product-top > img {
  z-index: 1;
  height: 100%;
  /* width: 140px; */
  transition: all 0.4s ease-in-out;
}

/* .q-sv-single-product:hover>.q-sv-single-product-top>img {
  height: 100%;
  width: 100%;
} */

.q-sv-single-product > .q-sv-single-product-bottom {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.q-sv-single-product > .q-sv-single-product-bottom > h1 {
  color: #212121;
  font-size: 14px;
  font-family: QuicksandMedium !important;
  text-transform: capitalize !important;
}

/* @media (max-width:768px) { */
.single-product-card-heading {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  /* height: 30px; */
}

.single-product-card-title-link {
  width: 100%;
  display: block;
  border-radius: 4px;
  color: inherit;
  text-decoration: none;
}

.single-product-card-title-link:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.24);
  outline-offset: 2px;
}
/* } */

@media (max-width: 768px) {
  .single-product-card-heading {
    height: 30px;
  }
}
.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-amount {
  margin: 4px 0;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-amount
  > span {
  color: #0a64f9;
  font-size: 18px;
  font-family: QuicksandBold !important;
  margin-right: 10px;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-amount
  > del {
  color: #888888;
  font-size: 14px;
  font-family: QuicksandMedium !important;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > Button {
  width: 75%;
  display: flex !important;
  align-items: center !important;
  /* justify-content: space-around !important; */
  background: #0a64f9;
  border-radius: 4px;
  color: #ffffff;
  /* font-size: 14px; */
  font-size: clamp(10px, 0.05px + 2.6783vw, 14px) !important;
  font-family: QuicksandMedium !important;
  text-transform: capitalize !important;
  padding: 6px 8px 6px 8px;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
}
@media (min-width: 806px) and (max-width: 822px) {
  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > Button {
    font-size: 12px !important;
  }
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > Button
  p {
  /* margin-left: 5%; */
  white-space: nowrap;
  /* font-size: clamp(12px, 0.1px + 0.98783vw, 14px) !important; */
  font-size: 14px;
}

.q-sv-single-product .out-of-stock-btn {
  background-color: rgb(255, 255, 255) !important;
  color: red !important;
  border: 1px solid red;
}

.out-of-stock-btn-single-product-page {
  margin: 24px 0 !important;
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: rgb(255, 255, 255) !important;
  color: red !important;
  border: 1px solid red !important;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-family: QuicksandMedium !important;
  text-transform: capitalize !important;
  height: 44px !important;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > .remove-wish {
  background: #fff5f5;
  border-radius: 4px;
  padding: 7px 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.remove-wish img {
  width: 20px;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > .add-wish {
  display: flex;
  background: #eef4ff;
  border-radius: 4px;
  cursor: pointer;
  height: 44px;
  position: relative;
  width: 38px;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .q-sv-single-product
    > .q-sv-single-product-bottom
    > .q-sv-single-product-bottom-purchase
    > .add-wish {
    margin-top: 5px;
  }
}

.q-sv-single-product .single-p-select-variant-btn {
  width: 75%;
  color: #000000;
  border: 1px solid #000000;
  border-radius: 4px;
  background: #fff;
  /* font-size: 14px; */
  font-size: clamp(10px, 0.05px + 2.6783vw, 14px) !important;
  font-family: QuicksandMedium !important;
  border-radius: 4px;
  padding: 8px 0px;
  text-align: center;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  cursor: pointer;
}

.q-sv-single-product .single-p-select-variant-btn:focus-visible {
  outline: 3px solid rgba(10, 100, 249, 0.24);
  outline-offset: 2px;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > .product-qti-button {
  color: #000;
  display: flex;
  align-items: center !important;
  justify-content: space-between !important;
  cursor: auto;
  background: #fff !important;
  border-radius: 4px;
  width: 75%;
  padding: 7px;
  height: 44px;
  border: 1px solid #000;
}

.product-qti-button .css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #fff;
}

.q-sv-single-product-bottom-purchase
  > .product-qti-button
  > .add-remove-cart-btn {
  background: #000 !important;
  width: auto !important;
  padding: 4px 5px !important;
  box-shadow: none !important;
  min-width: unset !important;
  border: 1px solid #000 !important;
  height: 28px;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > .product-qti-button
  > svg {
  cursor: pointer;
}

.q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > .product-qti-button
  > span {
  font-size: 16px;
  font-family: QuicksandMedium !important;
  color: #000000;
}

/* end single product*/

/* Start Featured categories */
.single-store-featured-categories-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}

.single-store-featured-categories-section > h1 {
  color: #212121;
  font-size: 26px;
  font-family: QuicksandBold !important;
}

.single-store-featured-categories-section > .all-featured-categories {
  margin: 10px 0;
  width: 100%;
  overflow: hidden;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
}

.featured-categories-scrollable-row {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: flex-start;
}

.single-featured-category {
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px;
  margin-right: 10px;
  width: 250px;
  height: 60px;
  scroll-snap-align: start;
  touch-action: pan-y;
}

.single-featured-category > img {
  width: 45px;
  object-fit: contain;
}

.single-featured-category > .single-featured-category-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0 0 0 10px;
  min-width: 100px;
}

.single-featured-category > .single-featured-category-content > span {
  color: #212121;
  font-size: 12px;
  font-family: QuicksandBold !important;
}

.single-featured-category > .single-featured-category-content > p {
  color: #212121;
  font-family: QuicksandRegular !important;
  font-size: 11px;
}

.quickvee-highest-selling-product-section .slick-slider .slick-prev {
  right: 55px;
  top: -32px;
}

.quickvee-highest-selling-product-section .slick-slider .slick-next {
  right: 16px;
  top: -32px;
}

/* End Featured categories */

/*  Start SingleStoreAllInformationPage */
.SingleStoreAllInformationPage {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* overflow: hidden; */
}

.single-store-banners-images {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.single-store-banners-images > a {
  margin: 10px 10px 10px 0;
  width: 35%;
}

.single-store-banners-images > a > img {
  width: 100%;
  height: auto;
}

.single-store-sproductListing-section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.single-store-sproductListing-section > section {
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  margin: 0px 0px 0px 0;
}

.single-store-sproductListing-section > section > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* width: 200px; */
}

.single-store-sproductListing-section > section > div > a {
  color: #0a64f9;
  font-size: 17px;
  font-family: QuicksandBold !important;
}

.single-store-sproductListing-section
  > section
  > div
  > .search-category-store-image-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100px;
}

/* .single-store-sproductListing-section>section> div > div  > img{
  cursor: pointer;
} */

.slick-next {
  right: 95px;
  top: -20px;
  z-index: 1;
  /* background: black; */
  width: 31px;
  height: 27px;
}

.slick-next.slick-disabled:before {
  cursor: default !important;

  opacity: 1;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
}

.slick-next:before {
  opacity: 1;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) !important;
}

.slick-prev {
  right: 133px;
  left: unset !important;
  top: -20px;
  width: 31px;
  height: 27px;
}

.slick-prev.slick-disabled:before {
  cursor: default !important;
  opacity: 1;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) !important;
}

.slick-prev:before {
  opacity: 1;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) !important;
}

.single-store-sproductListing-section > section > span {
  color: #212121;
  font-size: 24px;

  font-family: QuicksandBold !important;
}

@media (max-width: 820px) {
  .single-store-sproductListing-section > section > span {
    font-size: clamp(22px, 0.05px + 2.1783vw, 24px) !important;
  }
}

.single-store-sproductListing-section > .single-store-sproductListing-products,
.slick-slider .slick-initialized {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  /* flex-wrap: wrap; */
}

.single-store-single-category-product-listing-section {
  /* margin: 0px 5px; */
  min-height: calc(100vh - 137px) !important;
}

.single-store-single-category-product-listing {
  /* width: 100%; */
  /* display: flex; */
  /* flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start; */
  margin: 10px -15px;
  /* display: inline-block; */
}

.single-store-single-category-product-listing.loading {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  /* min-height: calc(100vh - 137px) !important;  */
}

.product-in-category {
  width: 20%;
  padding-left: 15px;
  display: inline-block;
  padding-right: 15px;
  float: left;
}

.single-selectCategory-product-listing > .q-single-category-headings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  position: relative;
}

.single-selectCategory-product-listing > .q-single-category-headings > span {
  color: #212121;
  font-size: 24px;
  font-family: QuicksandBold !important;
}

.select-box {
  position: absolute;
  right: 0px;
  display: block;
  width: 230px;
  margin: 0 auto;
  font-family: QuicksandMedium, sans-serif !important;
  font-size: 18px;
  color: #000000;
  z-index: 1;
}

.select-box__current {
  position: relative;
  cursor: pointer;
  outline: none;
}

.select-box__current:focus + .select-box__list {
  opacity: 1;
  animation-name: none;
}

.select-box__current:focus + .select-box__list .select-box__option {
  cursor: pointer;
}

.select-box__current .select-box__icon {
  /* transform: translateY(-50%) rotate(180deg); */
}

.select-box__current:focus .select-box__icon {
  transform: translateY(-50%) rotate(0deg);
}

.select-box__icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 20px;
  opacity: 1;
  transition: 0.2s ease;
}

.select-box__value {
  display: flex;
}

.select-box__input {
  display: none;
}

.select-box__input:checked + .select-box__input-text {
  display: block;
  /* border: 1px solid #000000; */
  border-radius: 7px;
  font-size: 16px;
}

.select-box__input-text {
  display: none;
  width: 100%;
  margin: 0;
  padding: 10px;
  background-color: #fff;
  text-align: end;
  padding-right: 48px;
}

.select-box__list {
  z-index: -1;
  overflow: hidden;
  /* border: 1px solid #707070; */
  /* border-radius: 7px 7px 7px 7px; */
  border-radius: 8px;
  box-shadow: 0px 6px 15px #0a64f94d;
  position: absolute;
  top: 38 px;
  width: 100%;
  padding: 0;
  list-style: none;
  opacity: 0;
  animation-name: HideList;
  animation-duration: 0.5s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  animation-timing-function: step-start;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.select-box__option {
  font-size: 16px;
  font-family: QuicksandMedium !important;
  color: #414141;
  display: block;
  padding: 10px 15px;
  background-color: #fff;
}

.select-box__option:hover,
.select-box__option:focus {
  color: #000000;
  background-color: #fbfbfb;
}

.sort-by:hover,
.sort-by:focus {
  color: #414141 !important;
  background-color: #fbfbfb;
  cursor: auto !important;
}

@keyframes HideList {
  from {
    transform: scaleY(1);
  }

  to {
    transform: scaleY(0);
  }
}

/*  End SingleStoreAllInformationPage */

/* Start Wishlist */
.single-store-wishlist {
  display: flex;
  flex-wrap: wrap;
}

/* .single-store-wishlist div {
  margin-right: 26px;
  width: 242px;
} */

/* .single-store-wishlist
  > .q-sv-single-product
  > .q-sv-single-product-bottom
  > .q-sv-single-product-bottom-purchase
  > .add-wish {
  right: 19px;
  height: 37px;
} */

.single-store-empty-wishlist {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 80vh;
}

.empty-wishlist-content {
  width: 300px;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-wishlist-content img {
  width: 80px;
  margin-bottom: 20px;
}

.empty-wishlist-content h1 {
  font-family: QuicksandSemiBold !important;
  font-size: 19px;
  color: #232323;
}

.empty-wishlist-content p {
  font-family: QuicksandSemiBold !important;
  font-size: 13px;
  color: #878787;
  margin: 15px auto;
  margin-bottom: 15px !important;
}

.empty-wishlist-content .continue-shopping-on-wishlist {
  color: #0a64f9;
  width: 200px;
  border: 2px solid #0a64f9;
  background: #fff;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  text-transform: capitalize !important;
  background: #ffffff;
  border-radius: 5px;
}

.continue-shopping-on-wishlist:hover {
  background: #fff !important;
}

.continue-shopping-on-wishlist a {
  text-decoration: none;
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
}

/* End Wishlist */

/* Start Wishlist */
.single-store-loyalty-point {
  display: flex;
  flex-wrap: wrap;
}

.single-store-empty-loyalty-point {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 55vh;
}

.empty-loyalty-point-content {
  /* width: 300px; */
  /* height: 70vh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-loyalty-point-content img {
  width: 80px;
  margin-bottom: 20px;
}

.empty-loyalty-point-content h1 {
  font-family: QuicksandSemiBold !important;
  font-size: 19px;
  color: #232323;
}

.empty-loyalty-point-content p {
  font-family: QuicksandSemiBold !important;
  font-size: 13px;
  color: #878787;
  margin: 15px auto;
  margin-bottom: 15px !important;
}

.empty-loyalty-point-content .continue-shopping-on-loyalty-point {
  color: #0a64f9;
  width: 200px;
  border: 2px solid #0a64f9;
  background: #fff;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
  text-transform: capitalize !important;
  background: #ffffff;
  border-radius: 5px;
}

.continue-shopping-on-loyalty-point:hover {
  background: #fff !important;
}

.continue-shopping-on-loyalty-point a {
  text-decoration: none;
  color: #0a64f9;
  font-size: 14px;
  font-family: QuicksandSemiBold !important;
}

/* End Wishlist */

/* Start HomePage */
.home-page-all-sections {
  min-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 80%;
  margin: 0 auto;
}

.home-page-all-sections > div {
  margin: 10px auto;
  width: 100%;
}

.home-categories {
  width: 100%;
  overflow: hidden;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.single-home-categorie {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px;
}

.single-home-categorie > .single-home-categorie-image-section {
  height: 100px;
  width: 100px;
  border: 1px solid #eee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0 auto;
  /* background-color: red; */
}

.single-home-categorie > span {
  justify-content: center;
  text-align: center;
  margin: 8px 0 0 0;
  font-family: QuicksandMedium !important;
  font-size: 16px;
  color: #131313;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.quickvee-home-stores {
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.quickvee-home-stores > h1 {
  font-size: 24px;
  color: #212121;
  font-family: QuicksandBold !important;
}

.quickvee-home-all-stores {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  align-items: center;
  justify-content: flex-start;
}

.quickvee-home-single-store {
  margin: 20px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

@media (min-width: 1000px) {
  .quickvee-home-single-store {
    width: 21%;
    margin: 2%;
    display: flex;
    align-self: flex-start;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}

.quickvee-home-single-store > a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.q-store-image-section {
  position: relative;
  border: 2px solid #f2f2f2;
  width: 130px;
  height: 130px;
  border-radius: 100px;
  overflow: hidden;
  text-align: center;
}

.q-store-image-section img {
  width: 90%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 10px;
  transform: translate(-50%, -50%);
}

.q-store-content-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  text-align: center;
  width: 238px;
}

.q-store-content-section > span {
  margin-top: 10px;
  /* font-size: 18px; */
  font-size: clamp(16px, 0.05px + 2.6783vw, 18px) !important;
  color: #232323;
  font-family: QuicksandBold !important;
}

.q-store-content-section > p {
  font-size: 13px;
  color: #232323;
  font-family: QuicksandMedium !important;
}

.quicvee-home-banner {
  margin: 40px 0;
  width: 100%;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
}

.quicvee-home-banner > .quickvee-home-banner-image {
  height: auto;
  width: 100%;
  object-fit: contain;
}

/*  search box  */

.search-data-box::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.search-data-box::-webkit-scrollbar-track {
  background-color: #fff;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.search-data-box::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.search-data-box::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.search-data-box {
  z-index: 5;
  left: 250px;
  top: 55px;
  width: 50vw;
  overflow-y: auto;
  position: absolute;
  height: auto;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 6px 15px #0a64f94d;
  max-height: 473px;
  overflow-x: hidden;
  padding: 5px 0px;
}

.search-data-box > a {
  display: block;
  width: 100%;
  /* border-bottom: 1px solid #E1E1E1; */
  padding: 10px 10px;
}

.search-bar-link {
  /* font-family: QuicksandMedium !important; */
  /* width: 100%; */
  color: #202020 !important;
  font-size: 14px;
  padding-inline: 10px;
}

.search-bar-link:visited {
  color: #202020 !important;
}

.online-o-page-profile-box {
  text-align: start;
  z-index: 5;
  right: 110px;
  top: 50px;
  width: 140px;
  position: absolute;
  height: auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  box-shadow: 0px 6px 15px #0a64f94d;
  padding: 5px;
  flex-direction: column;
  position: absolute;
  right: 0;
  margin-right: 2%;
  bottom: 0;
  display: inline-table;
}

.online-o-page-profile-box > .profile-bar-link {
  text-align: start;
  text-decoration: none !important;
  font-family: QuicksandMedium !important;
  width: 100%;
  color: #000000 !important;
  font-size: 14px;
  padding: 7px;
  display: block;
}

.online-o-page-profile-box > .profile-bar-link-logout {
  text-transform: capitalize;
  font-family: QuicksandMedium !important;
  /* margin-left: -31px; */
}

.online-o-page-profile-box > .profile-bar-link-logout:hover {
  background: none !important;
}

.online-o-page-profile-box > .profile-bar-link:nth-child(0) {
  border-bottom: 1px solid #e1e1e1;
}

.online-o-page-profile-box > .profile-bar-link:nth-child(1) {
  border-bottom: 1px solid #e1e1e1;
}

.online-o-page-profile-box > .profile-bar-link:nth-child(2) {
  border-bottom: 1px solid #e1e1e1;
}

.top-bar-button:hover {
  background: none !important;
}

/* End Homepage */

/* Start Footer */
.footer_area {
  width: 100%;
  height: auto;
  background: #f6f6f6;
  padding: 10px 0;
  float: left;
  margin-top: 20px;
}

.footer_area_inner {
  width: 74%;
  height: auto;
  margin: 0 auto;
}

.footer_area_inner.footer_area_inner_menu {
  width: 100%;
  height: auto;
  padding-left: 18%;
  padding-right: 2%;
  display: inline-block;
}

.footer_areaL {
  width: 40%;
  height: auto;
  float: left;
}

.footer_areaL p {
  display: inline-block;
  font-size: 12px;
  color: #707070;
  font-family: 'QuicksandMedium';
}

.footer_areaR {
  width: 60%;
  height: auto;
  float: left;
}

.footer_areaR ul {
  list-style: none;
  float: right;
  padding: 0px;
}

.footer_areaR ul li {
  float: left;
  padding: 0 10px;
  border-right: 1px solid #707070;
  display: inline-block;
}

.footer_areaR ul li:last-child {
  border-right: none;
  padding-right: 0px;
}

.footer_areaR ul li a {
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  color: #707070;
  font-family: 'QuicksandMedium';
}

.footer_areaR ul li a:hover {
  color: #0a64f9;
}

/* End Footer */

/* Start Header*/

.header_area {
  width: 100%;
  height: auto;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 10px 0;
  position: sticky;
  top: 0;
  z-index: 99;
  margin-bottom: 10px;
}

.quickvee_logo {
  width: 148px;
  height: 44px;
}

.header_area_box {
  display: flex;
  align-items: center;
  width: 80%;
  height: auto;
  margin: 0 auto;
}

.header_area_box > .other-header-items {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.logo_area {
  width: auto;
  float: left;
  margin-right: 20px;
}

.home_page_top_category_div {
  /* width: 173px !important; */
  height: auto;
  padding: 0 10px;
  text-align: center;
}

.home_page_top_category_div > .q-single-category-link-home {
  text-decoration: none !important;
  display: inline-block;
}

.q-single-category-link-home > span {
  text-decoration: none !important;
  display: inline-block;
  color: #000 !important;
  margin-top: 10px;
  font-family: QuicksandMedium !important;
}

.home_page_top_category_div_inner {
  width: 100px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 100px;
  overflow: hidden;
  margin: 0 auto;
}

.home_page_top_category_div_inner img {
  width: 100%;
}

.links-div {
  position: relative;
}

.home-page-link-box {
  z-index: 5;
  left: 0px;
  /* top: 50px; */
  width: 130px;
  position: absolute;
  height: auto;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  box-shadow: 0px 6px 15px #0a64f94d;
  padding: 5px;
  flex-direction: column;
}

.home-page-link-box > .profile-bar-link {
  text-decoration: none !important;
  font-family: QuicksandMedium !important;
  width: 100%;
  color: #000000 !important;
  font-size: 14px;
  padding: 7px;
}

.home-page-link-box > .profile-bar-link:nth-child(1) {
  border-bottom: 1px solid #e1e1e1;
}

.home-search-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}

.logo-image-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

.logo-image {
  width: 35px;
  border-radius: 50%;
  border: 1px solid rgb(193 193 193);
  margin-right: 20px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* ..home-search-items:hover {
  background-color: red;
} */

.home-search-items img {
  /* display: none; */
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid rgb(193 193 193);
  /* margin-right: 20px; */
}

.home-search-data-box::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.home-search-data-box::-webkit-scrollbar-track {
  background-color: #fff;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  cursor: pointer;
}

/* Handle */
.home-search-data-box::-webkit-scrollbar-thumb {
  background: #3e85f8;
  border-radius: 10px;
  cursor: pointer;
  -webkit-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  outline: 1px solid #fff;
}

/* Handle on hover */
.home-search-data-box::-webkit-scrollbar-thumb:hover {
  background: #0a64f9;
  cursor: pointer !important;
}

.home-search-data-box {
  z-index: 5;
  left: 302px;
  top: 63px;
  width: 35vw;
  overflow-y: auto;
  position: absolute;
  height: auto;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 6px 15px #0a64f94d;
  max-height: 432px;
  overflow-x: hidden;
  padding: 5px 0px;
}

.home-search-data-box > div {
  width: 100%;
  /* border-bottom: 1px solid #E1E1E1; */
  padding: 10px 10px;
}

/* End Header*/

/* Start Search category*/
/* .search-category-visit-store-btn {
  background: #0A64F9;
  color: #FFF !important;
  font-size: 15px !important;
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #0A64F9;
  cursor: pointer;
  transition: all 0.4s ease-in-out;
}

.search-category-visit-store-btn:hover {
  background: #FFF;
  color: #0A64F9 !important;
} */

/* Start Search category*/
/* .search-category-visit-store-btn {
  background: #0A64F9;
  color: #FFF !important;
  font-size: 15px !important;
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #0A64F9;
  cursor: pointer;
  transition: all 0.4s ease-in-out;
}

.search-category-visit-store-btn:hover {
  background: #FFF;
  color: #0A64F9 !important;
} */

/* Start Search category*/
.search-category-visit-store-btn {
  background: transparent;
  font-weight: 500;
  font-size: 16px;
  color: #000;
  flex-shrink: 0;
  /* color: #fff !important; */
  /* color: inherit;
  font-size: 15px !important;
  padding: 6px 10px 6px 10px;
  border-radius: 6px;
  border: 1px solid #0a64f9; */
  cursor: pointer;
  transition: all 0.4s ease-in-out;
}

@media (max-width: 1024px) {
  .search-category-visit-store-btn {
    border: 0;
    padding: 6px 0px 6px 0px;
  }
}

/* .search-category-visit-store-btn:hover {
  background: #fff;
  color: #0a64f9 !important;
} */

.search-category-page-store-detail {
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  flex: 1.5 1 !important;
}
@media (max-width: 480px) {
  .search-category-page-store-detail {
    display: unset !important;
  }
}

.search-category-page-store-detail > .search-category-store-image-div {
  width: 75px !important;
  height: 74px;
  float: left;
  border: 2px solid #f2f2f2;
  border-radius: 100px;
  overflow: hidden;
  padding: 8px;
  text-align: center;
  margin-right: 16px;
  position: relative;
}

.search-category-page-store-detail > .search-category-store-image-div img {
  width: 100%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.search-category-page-store-description {
  /* width: 230px;
  height: 74px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search-category-page-store-description > span {
  text-transform: capitalize !important;
  font-family: QuicksandBold !important;
}

.search-category-page-store-description > p {
  font-size: 13px;
  text-transform: capitalize;
  font-family: 'QuicksandMedium';
}

/*End Search category*/

.profile-page-user-data-button {
  display: flex;
  align-items: center;
  padding: 3px 15px;
  background: #fff !important;
  color: #232323 !important;
  padding: 0px;
}

.profile-page-user-data-button > img {
  margin-top: -3px !important;
  width: 22px;
}

/* LoyaltyPointsZone Start */
.loyalty-point-zone-page {
  width: 100%;
  margin-left: 250px;
  height: 85vh;
}

.loyalty-point-zone-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-position: right center, left top;
  /* background-position: 300px,800px; */
  background-repeat: no-repeat, repeat;
  background-size: contain, cover;

  width: 100%;
  height: 200px;
  display: flex;
  padding: 40px 60px 60px 60px;
}

@media (max-width: 768px) {
  .loyalty-point-zone-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}),
      url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    /* background-position: right center, left top; */
    background-position: 50px, 800px;
    background-repeat: no-repeat, repeat;
    background-size: cover;

    width: 100%;
    height: 200px;
    display: flex;
    padding: 40px 60px 60px 20px;
  }
}

.loyalty-point-zone-top-detail > span {
  font-size: clamp(1rem, 1rem + 3.6783vw, 5rem) !important;
}

.loyalty-point-zone-top-detail > p {
  font-size: clamp(14px, 1px + 4.6783vw, 18px) !important;
}

.loyalty-point-zone-top-detail {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.loyalty-point-zone-top-detail > p {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: QuicksandSemiBold !important;
  font-size: 18px;
  color: #fff;
}

.loyalty-point-zone-top-detail > p > span {
  margin-left: 10px;
}

.loyalty-point-zone-top-detail > span {
  font-size: 4rem;
  color: #fdba18;
  font-family: 'QuicksandBold';
}

.loyalty-point-zone-detail-section {
  margin: 20px 10%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  padding: 2%;
}

.loyalty-details-table {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.loyalty-order-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 2%;
  /* cursor: pointer; */
}

@media (max-width: 532px) {
  .loyalty-order-details div {
    font-size: 12px;
  }

  .loyalty-order-id {
    font-size: 12px !important;
  }

  .loyalty-pont-decrement {
    font-size: 12px !important;
  }
}

.loyalty-order-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5%;
}

.loyalty-point-increament {
  color: #10c558;
  font-size: 15px;
  font-family: QuicksandSemiBold !important;
}

.loyalty-pont-decrement {
  color: #f55353;
  font-size: 15px;
  font-family: QuicksandSemiBold !important;
  margin-top: 5px;
}

.loyalty-order-deatils {
  color: #0a64f9;
  font-size: 16px;
  font-family: QuicksandSemiBold;
}

@media (max-width: 480px) {
  .loyalty-order-deatils {
    display: none !important;
  }
}

.loyalty-order-point {
  color: #2e2e2e;
  font-size: 15px;
  font-family: QuicksandMedium;
}

.loyalty-order-id {
  color: #707070;
  font-size: 14px;
  font-family: QuicksandMedium;
  margin-top: 5px;
}

.loyalty-details-table > p {
  color: #212121;
  font-size: 16px;
  font-family: QuicksandSemiBold !important;
}

.loyalty-order-deatils {
  color: #0a64f9;
  font-size: 16px;
  font-family: QuicksandSemiBold;
}

.loyalty-order-point {
  color: #2e2e2e;
  font-size: 15px;
  font-family: QuicksandMedium;
}

.loyalty-order-id {
  color: #707070;
  font-size: 14px;
  font-family: QuicksandMedium;
  margin-top: 5px;
}

.loyalty-details-table > p {
  color: #212121;
  font-size: 16px;
  font-family: QuicksandSemiBold !important;
}

.loyalty-border-line {
  border-bottom: 1px solid #e9e9e9;
  margin-top: 20px;
  opacity: 1;
}

/* LoyaltyPointsZone End */

/* Store Credit points */
.StoreCredit-point-zone-page {
  width: 100%;
  /* height: auto; */
  margin-left: 250px;
}

@media (max-width: 768px) {
  .StoreCredit-point-zone-page {
    margin-left: 0;
  }
}

.StoreCredit-zone-detail-section {
  margin: 6%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 50px;
  /* padding-bottom: 50%; */
}

.loyalty-border-line {
  border-bottom: 1px solid #e9e9e9;
  margin-top: 20px;
  opacity: 1;
}

/* LoyaltyPointsZone End */

/* View Hours */

.hours-option-main {
  display: flex !important;
  align-items: start !important;
  justify-content: space-between !important;
  flex-wrap: wrap;
}
.full-hours-data-detail .hours-options {
  background-color: #f6f6f6;
  width: 24%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 6px;
  margin: 2px;
}
.full-hours-data-detail .hours-options img {
  width: 22px;
  height: 22px;
  margin-bottom: 6px;
}

.hours-options p {
  color: #515151;
  font-size: 12px;
  font-weight: 400;
  font-family: Jost !important;
}

.hours-options span {
  color: #515151;
  font-size: 14px;
  font-weight: 600;
  font-family: Jost !important;
}

@media (max-width: 560px) {
  .full-hours-data-detail .hours-options {
    background-color: #f6f6f6;
    width: 48%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 6px;
    margin: 2px;
  }
}

@media (max-width: 568px) {
  #modal-view-full-hours-header > span {
    font-size: 21px;
  }
}

/* Wishlist Start */
.wishlist_container{
  margin-left: 1rem;
}
.wishlist-modal{
  padding: 1rem 2rem !important;
  border: 0px !important;
}
.wishListContainer{
  border-top: 0.1px solid #cbc8c8;;
  margin: 0rem 2rem;
   max-height: 300px;
  overflow-y: auto;
}
.wishlistCross{
  width: 13px;
  filter: drop-shadow(0px 0.5px 0.5px black);
}
.modalTitle{
  color: #2D2A6E !important;
  text-transform: unset !important;
}
.wishlsitBtn_conatiner{
  padding: 1rem 2rem !important;
  display: flex;
  justify-content: space-between;

}
.createwishlsitBtn_conatiner{
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.wishlistDoneBTn,.createwishlistDoneBTn{
  width: 7.5rem;
}

.new_wishlist{
  appearance: none;
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  font: inherit;
  font-weight: 500;
  padding: 0;
  cursor: pointer;
}
.checkbox_list{
  display: flex;
  align-items: center;
  gap: 10px;
  /* border: 1px solid #0d6efd; */
  border-radius: 0.75rem;
  padding: 12px 0px 12px 16px;
  margin-top: 1rem;
  cursor: pointer;
}

/* Custom box */

  .wishlist_input:checked ~ .category-checkmark {
    background-color: #108910;
    border-color: #108910;
  }

  .wishlist_input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

/* Remove unwanted autofill styling */
  .wishlist_input:-webkit-autofill {
    box-shadow: unset !important;
    -webkit-text-fill-color: unset !important;
  }

/* Label */
.checkbox_list {
  position: relative;
  padding-left: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}

.category-checkmark {
    position: absolute;
    left: 12px;
    top: 15px;
    width: 16px;
    height: 16px;
    border: 1px solid #a19f9f;
    border-radius: 3px;
    background-color: transparent;
}


/* White tick mark */
.category-checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

.wishlist_input:checked ~ .category-checkmark::after {
    display: block;
    left: 4.5px;
    top: 1.25px;
    width: 5px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}



  .wishHeading{
    color: #000000 !important;
    font-weight: 500;
  }




/* Wishlist End */


`, "",{"version":3,"sources":["webpack://./src/Styles/Product.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,4CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,4CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,4CAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,4CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB;sBACoB;EACpB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,kBAAkB;;EAElB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,mCAAmC;EACnC,OAAO;EACP,QAAQ;AACV;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;;EAGE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;EACrC,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;EAGE,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,2CAA2C;EAC3C,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;;;;YAIU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;;;EAIE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;EAGE,8BAA8B;EAC9B,2DAA4D;AAC9D;;AAEA;;;EAGE,8BAA8B;EAC9B,2DAAqE;AACvE;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2DAA4D;EAC5D,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,2DAA4D;AAC9D;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2DAAqE;EACrE,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,2DAAqE;AACvE;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2DAA0D;EAC1D,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,2DAA0D;AAC5D;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;EAGE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;;;EAGE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;EACE,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,yCAAyC;EACzC,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC;;gBAEc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;EAKE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,+BAA+B;AACjC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB,sBAAsB;;AAEtB,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;EAKE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;;;EAIE,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;;;EAIE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA,kBAAkB;;AAElB,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;;GAEG;AACH;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,eAAe;AACjB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;EACzC,+CAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;;GAEG;AACH;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;EAC5B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,yCAAyC;EACzC,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,eAAe;AACjB;;AAEA;;;EAGE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,0BAA0B;EAC1B,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA,8BAA8B;;AAE9B,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;;IAElB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,UAAU;EACV,wBAAwB;EACxB;cACY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA,MAAM;;AAEN;EACE;IACE,YAAY;EACd;AACF;AACA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,eAAe;EACf,uCAAuC;AACzC;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;;;;EAIE,UAAU;EACV,wBAAwB;EACxB,8BAA8B;EAC9B,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,0DAA0D;EAC1D,uCAAuC;EACvC,qCAAqC;EACrC,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;;;;;EAKE,qBAAqB;EACrB,mBAAmB;EACnB,gEAAgE;EAChE,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,+CAA+C;EAC/C,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;;;;IAIE,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;EAC1D,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,yCAAyC;EACzC,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,YAAY;AACd;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;EACf,uCAAuC;EACvC,cAAc;AAChB;;AAEA,sBAAsB;;AAEtB,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EAEzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA,4BAA4B;;AAE5B,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;;;;EAIE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;;EAE1B,UAAU;EACV,2DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,2DAA+D;AACjE;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,4DAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,4DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,eAAe;;EAEf,qCAAqC;AACvC;;AAEA;EACE;IACE,0DAA0D;EAC5D;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB;;gCAE8B;EAC9B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,cAAc;EACd,mDAAmD;EACnD,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EAEV,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,UAAU;EAEV,wBAAwB;EAExB,wBAAwB;EAExB,qBAAqB;EAErB,6BAA6B;EAE7B,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB;;AAYA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uCAAuC;;AAEvC,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;;;;;;;GAOG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA,iBAAiB;;AAEjB,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA,iBAAiB;;AAEjB,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;EAC1D,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,uCAAuC;EACvC,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;;AAEjB,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;;AAEf,gBAAgB;;AAEhB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,+CAAuC;EAAvC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA,cAAc;;AAEd,yBAAyB;AACzB;;;;;;;;;;;;;;GAcG;;AAEH,yBAAyB;AACzB;;;;;;;;;;;;;;GAcG;;AAEH,yBAAyB;AACzB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B;;;;8BAI4B;EAC5B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE;IACE,SAAS;IACT,wBAAwB;EAC1B;AACF;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,sBAAoB;AACtB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE;iBACe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;4CACyD;EACzD,2CAA2C;EAC3C,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;;EAE/B,WAAW;EACX,aAAa;EACb,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;IACE;8CACyD;IACzD,iDAAiD;IACjD,gCAAgC;IAChC,oCAAoC;IACpC,sBAAsB;;IAEtB,WAAW;IACX,aAAa;IACb,aAAa;IACb,4BAA4B;EAC9B;AACF;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,yCAAyC;EACzC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,0BAA0B;;AAE1B,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,0BAA0B;;AAE1B,eAAe;;AAEf;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,iBAAiB;GAChB,iBAAiB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;;EAEb;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;EACjB;;AAEF,qCAAqC;EACnC;IACE,4BAA4B;IAC5B,yCAAyC;EAC3C;;AAEF,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;AACjC;;;AAGA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;;;EAIE;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;;;;AAKF,iBAAiB","sourcesContent":["a {\r\n  text-decoration: none !important;\r\n}\r\n\r\n@font-face {\r\n  font-family: QuicksandLight;\r\n  src: url(../Assets/fonts/Quicksand-Light.ttf);\r\n}\r\n\r\n@font-face {\r\n  font-family: QuicksandBold;\r\n  src: url(../Assets/fonts/Quicksand-Bold.ttf);\r\n}\r\n\r\n@font-face {\r\n  font-family: QuicksandMedium;\r\n  src: url(../Assets/fonts/Quicksand-Medium.ttf);\r\n}\r\n\r\n@font-face {\r\n  font-family: QuicksandRegular;\r\n  src: url(../Assets/fonts/Quicksand-Regular.ttf);\r\n}\r\n\r\n@font-face {\r\n  font-family: QuicksandSemiBold;\r\n  src: url(../Assets/fonts/Quicksand-SemiBold.ttf);\r\n}\r\n\r\n@font-face {\r\n  font-family: QuicksandLight;\r\n  src: url(../Assets/fonts/Quicksand-Light.ttf);\r\n}\r\n\r\n/* Start Single Store  */\r\n.quickvee-single-store-top-bar {\r\n  flex-wrap: wrap;\r\n  z-index: 100;\r\n  position: sticky;\r\n  top: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 5px 20px;\r\n  /* padding-left: 3%;\r\n  padding-right: 3%; */\r\n  background-color: #fff;\r\n  border: 1px solid #ebebeb;\r\n}\r\n@media (max-width: 768px) {\r\n  .quickvee-single-store-top-bar {\r\n    padding: unset;\r\n    padding-left: 3%;\r\n    padding-right: 3%;\r\n  }\r\n}\r\n.quickvee-single-store-top-bar > .quickvee-logo-icon-single-store {\r\n  width: 250px;\r\n}\r\n\r\n.quickvee-single-store-offer-coupon {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 20px;\r\n  width: auto;\r\n  position: relative;\r\n\r\n  /* justify-content: center; */\r\n}\r\n\r\n.quickvee-single-store-offer-coupon > .quickvee-single-store-offer-button {\r\n  width: 100%;\r\n  background-color: #fff !important;\r\n  padding: 6px 16px !important;\r\n  color: #0a64f9;\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n  transition: all 0.4s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-offer-coupon\r\n  > .quickvee-single-store-offer-button\r\n  > span {\r\n  color: #232323;\r\n  text-transform: uppercase;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-store-offer-coupon\r\n  > .quickvee-single-store-offer-button:hover {\r\n  box-shadow: 0px 6px 12px #00000029;\r\n}\r\n\r\n.quickvee-single-store-offer-coupon > .quickvee-single-store-offer-detail {\r\n  position: absolute;\r\n  margin-top: 40px;\r\n  /* width: 230px; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0px 6px 12px #00000029;\r\n  padding: 10px 0;\r\n  border-radius: 0px 0px 6px 6px;\r\n  border-top: 1px solid #ebebeb;\r\n  background-color: #fff;\r\n  animation: fadeIncoupon 0.3s linear;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n@keyframes fadeIncoupon {\r\n  0% {\r\n    opacity: 0.7;\r\n  }\r\n\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.quickvee-single-store-offer-coupon\r\n  > .quickvee-single-store-offer-detail\r\n  > .usecoupon-text {\r\n  color: #202020;\r\n  text-transform: capitalize;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n  margin: 5px 0;\r\n}\r\n\r\n.quickvee-single-store-offer-coupon\r\n  > .quickvee-single-store-offer-detail\r\n  > .coupon-copytext {\r\n  margin: 14px 0;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2px 6px 2px 26px;\r\n  background: #f1f6ff;\r\n  color: #0a64f9;\r\n  text-transform: uppercase;\r\n  font-size: 20px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-store-offer-coupon\r\n  > .quickvee-single-store-offer-detail\r\n  > span {\r\n  color: #5d5d5d;\r\n  font-size: 9px;\r\n  font-family: QuicksandSemiBold;\r\n  margin: 2px 0;\r\n}\r\n\r\n.quickvee-single-store-top-bar\r\n  > .quickvee-single-store-login-and-wishlist-button {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.quickvee-customer-login-main {\r\n  position: relative;\r\n}\r\n\r\n.quickvee-customer-login {\r\n  background: #0a64f9 !important;\r\n  border-radius: 6px;\r\n  color: #ffffff;\r\n  font-size: 16px !important;\r\n  /* font-family: QuicksandBold !important; */\r\n  text-transform: capitalize;\r\n  padding: 10px 16px;\r\n  margin: 0 5px;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  height: 44px;\r\n  text-align: center;\r\n  min-width: 76px;\r\n}\r\n\r\n.quickvee-single-store-top-bar\r\n  > .quickvee-single-store-login-and-wishlist-button\r\n  > .quickvee-single-store-cart-button {\r\n  cursor: pointer;\r\n  background: #f6f7f8 !important;\r\n  border-radius: 6px !important;\r\n  padding: 6px 20px !important;\r\n  margin: 0 5px;\r\n  line-height: normal !important;\r\n  color: #232323;\r\n  font-size: 20px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-store-main-area {\r\n  display: flex;\r\n  /* overflow: hidden; */\r\n}\r\n\r\n.quickvee-single-store-left-menu {\r\n  background: #fff;\r\n  position: fixed;\r\n  left: 0;\r\n  width: 250px;\r\n  border-right: 1px solid #ebebeb;\r\n  height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  margin: 10px 0;\r\n  display: block;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.quickvee-single-store-left-menu::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n/* Track */\r\n.quickvee-single-store-left-menu::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Handle */\r\n.quickvee-single-store-left-menu::-webkit-scrollbar-thumb {\r\n  background: #3e85f8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease-in-out;\r\n  outline: 1px solid #fff;\r\n}\r\n\r\n/* Handle on hover */\r\n.quickvee-single-store-left-menu::-webkit-scrollbar-thumb:hover {\r\n  background: #0a64f9;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.quickvee-single-store-left-menu > .quickvee-left-menu-single-store-detail {\r\n  background-color: #fff;\r\n  /* margin: 10px 0 0 0; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* position: sticky;\r\n  width: 100%;\r\n  right: 0;\r\n  top: 0;\r\n  left: 0; */\r\n  padding: 0px 15px 0px 15px;\r\n}\r\n\r\n.quickvee-single-store-logo {\r\n  background: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 10px 10px 0;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 25;\r\n}\r\n\r\n.quickvee-single-store-logo a img {\r\n  object-fit: contain;\r\n  object-position: center;\r\n  border-radius: 100px;\r\n  border: 2px solid #f2f2f2;\r\n  overflow: hidden;\r\n  text-align: center;\r\n  padding: 10px;\r\n  position: relative;\r\n  width: 100px;\r\n  height: 100px;\r\n  left: 0px;\r\n  top: 0px;\r\n  transition: all 0.5s;\r\n}\r\n\r\n.quickvee-single-store-logo.scrolled a img {\r\n  position: relative;\r\n  width: 50px;\r\n  height: 50px;\r\n  left: -83px;\r\n  top: 0px;\r\n}\r\n\r\n.quickvee-single-store-logo > span {\r\n  border-radius: 12px;\r\n  color: #fff;\r\n  font-family: QuicksandMedium !important;\r\n  text-transform: uppercase;\r\n  padding: 2px 10px;\r\n  font-size: 13px;\r\n  margin-top: -12px;\r\n  z-index: 1;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail-sticky {\r\n  height: 100%;\r\n  transition: all 0.5s;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail-sticky.scrolled {\r\n  height: 5px;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail-sticky\r\n  > .quickvee-single-store-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0px 0px 0px 10px;\r\n  position: relative;\r\n  top: 0px;\r\n  right: 0px;\r\n  transition: all 0.5s;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail-sticky\r\n  > .quickvee-single-store-content.scrolled {\r\n  top: -50px;\r\n  right: -31px;\r\n  padding: 0px;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail-sticky\r\n  > .quickvee-single-store-content\r\n  > p {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  color: #2e2e2e;\r\n  text-transform: capitalize;\r\n  font-size: 12px;\r\n  font-family: QuicksandSemibold !important;\r\n  text-align: center;\r\n  margin: 5px 0;\r\n  position: relative;\r\n  right: 0px;\r\n  transition: all 0.5s;\r\n}\r\n\r\n/* .quickvee-left-menu-single-store-detail-sticky >.quickvee-single-store-content>p.scrolled{\r\n  right: -19px; \r\n} */\r\n\r\n.quickvee-left-menu-single-store-detail-sticky\r\n  > .quickvee-single-store-content\r\n  > span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #232323;\r\n  text-transform: capitalize;\r\n  font-size: 16px;\r\n  text-align: center;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail > .quickvee-single-store-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail > .quickvee-single-store-content > p {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  color: #2e2e2e;\r\n  text-transform: capitalize;\r\n  font-size: 12px;\r\n  font-family: QuicksandSemibold !important;\r\n  text-align: center;\r\n}\r\n\r\n.quickvee-left-menu-single-store-detail\r\n  > .quickvee-single-store-content\r\n  > span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #232323;\r\n  text-transform: capitalize;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-detail\r\n  > .quickvee-single-store-pickup-delivery {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  width: 100%;\r\n  background: #efefef;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-detail\r\n  > .quickvee-single-store-pickup-delivery\r\n  > Button {\r\n  width: 100%;\r\n  padding: 3px 25px;\r\n  background-color: none;\r\n  color: #928c8c;\r\n  font-size: 15px;\r\n  text-transform: capitalize !important;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-detail\r\n  > .quickvee-single-store-pickup-delivery\r\n  > Button {\r\n  width: 100%;\r\n  padding: 3px 25px;\r\n  background-color: #efefef;\r\n  color: #928c8c;\r\n  font-size: 15px;\r\n  text-transform: capitalize !important;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-detail\r\n  > .quickvee-single-store-pickup-delivery\r\n  > .active-delivery-button {\r\n  background: #000;\r\n  color: #ffffff;\r\n  font-size: 15px;\r\n  font-family: QuicksandMedium !important;\r\n  box-shadow: 0px 6px 12px #00000042;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist {\r\n  margin: 5px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.loading-category-menu-listing-elements {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link {\r\n  width: 98%;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 15px;\r\n  margin: 2px 0;\r\n  text-decoration: none;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link-active {\r\n  background: #ffffff !important;\r\n  box-shadow: 0px 6px 16px #0a64f936;\r\n  border: 1px solid #0a64f9;\r\n  border-radius: 5px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link-active\r\n  > .wishlist-icon {\r\n  background: #0a64f9 !important;\r\n  mask: url('../Assets/Store/FavouriteIcon.svg') no-repeat 0px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link-active\r\n  > .loyaltyIcon-icon {\r\n  background: #0a64f9 !important;\r\n  mask: url('../Assets/OrderScreen/LoyaltyPointIcon.svg') no-repeat 0px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link-active\r\n  > span {\r\n  color: #0a64f9 !important;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link:hover {\r\n  background: #f1f6ff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist > .quickvee-single-store-link > span {\r\n  color: #2e2e2e;\r\n  font-size: 16px;\r\n  font-family: QuicksandSemiBold !important;\r\n  transition: all 0.2s ease-in-out;\r\n  margin-left: 12px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link:hover\r\n  > span {\r\n  color: #6e81e2;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link\r\n  > .wishlist-icon {\r\n  background: #2e2e2e;\r\n  width: 20px;\r\n  height: 20px;\r\n  display: inline-block;\r\n  mask: url('../Assets/Store/FavouriteIcon.svg') no-repeat 0px;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link:hover\r\n  > .wishlist-icon {\r\n  background: #6e81e2;\r\n  mask: url('../Assets/Store/FavouriteIcon.svg') no-repeat 0px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link\r\n  > .loyaltyIcon-icon {\r\n  background: #2e2e2e;\r\n  width: 20px;\r\n  height: 20px;\r\n  mask: url('../Assets/OrderScreen/LoyaltyPointIcon.svg') no-repeat 0px;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link:hover\r\n  > .loyaltyIcon-icon {\r\n  background: #6e81e2;\r\n  mask: url('../Assets/OrderScreen/LoyaltyPointIcon.svg') no-repeat 0px;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link\r\n  > .reorder-icon {\r\n  background: #2e2e2e;\r\n  width: 20px;\r\n  height: 20px;\r\n  mask: url('../Assets/Store/ReorderIcon.svg') no-repeat 0px;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.quickvee-single-store-reorder-wishlist\r\n  > .quickvee-single-store-link:hover\r\n  > .reorder-icon {\r\n  background: #6e81e2;\r\n  mask: url('../Assets/Store/ReorderIcon.svg') no-repeat 0px;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-navigations {\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  display: block;\r\n}\r\n\r\n.quickvee-left-menu-single-store-navigations::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n/* Track */\r\n.quickvee-left-menu-single-store-navigations::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Handle */\r\n.quickvee-left-menu-single-store-navigations::-webkit-scrollbar-thumb {\r\n  background: #3e85f8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease-in-out;\r\n  outline: 1px solid #fff;\r\n}\r\n\r\n/* Handle on hover */\r\n.quickvee-left-menu-single-store-navigations::-webkit-scrollbar-thumb:hover {\r\n  background: #0a64f9;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-navigations\r\n  > .single-store-all-products {\r\n  font-size: 16px !important;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-navigations\r\n  > .single-store-product-active {\r\n  background: #f5f5f5;\r\n  border-left: 5px solid #232323;\r\n  font-size: 14px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-navigations\r\n  > a {\r\n  width: 100%;\r\n  text-decoration: none;\r\n  color: #2e2e2e;\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 14px;\r\n  padding: 10px 0 10px 20px;\r\n  border-left: 5px solid transparent;\r\n  transition: all 0.2s ease-in-out;\r\n  display: inline-block;\r\n}\r\n\r\n.quickvee-single-store-left-menu\r\n  > .quickvee-left-menu-single-store-navigations\r\n  .single-store-all-products-active {\r\n  background: #f5f5f5;\r\n  border-left: 5px solid #232323 !important;\r\n  font-family: QuicksandBold !important;\r\n  padding: 13px 10px 10px 20px;\r\n}\r\n\r\n.quickvee-single-store-main-area-detail-page {\r\n  margin-left: 15%;\r\n  width: calc(100% - 15%);\r\n  display: flex;\r\n  padding: 10px 20px 0px 20px !important;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* View Full Hours */\r\n\r\n.view-full-hour-link {\r\n  text-decoration: underline !important;\r\n  color: #3f882b !important;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #232323;\r\n  text-transform: capitalize;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.modal-view-full-hours-div:focus-visible {\r\n  outline: none !important;\r\n}\r\n\r\n.modal-view-full-hours-div {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 600px;\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  padding: 25px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n#modal-view-full-hours-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding-bottom: 10px;\r\n  margin-bottom: 8px;\r\n  box-sizing: border-box;\r\n  border-bottom: 2px solid #0000001a;\r\n}\r\n\r\n#modal-view-full-hours-header > span {\r\n  /* margin: 0 auto; */\r\n  font-weight: 600;\r\n  color: #2d2a6e;\r\n  font-size: 26px;\r\n  justify-self: center;\r\n  font-family: Jost;\r\n}\r\n\r\n.modal-view-full-hours-close {\n  padding: 5px;\n  display: inline-grid;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n}\n\n.modal-view-full-hours-close:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.22);\n  outline-offset: 2px;\n}\n\r\n.modal-view-full-hours-description {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data {\r\n  width: 100%;\r\n  overflow-x: hidden;\r\n  /* padding: 20px; */\r\n  box-sizing: border-box;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data > div {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  height: auto;\r\n  padding: 10px 0;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data .view-hour-today p {\r\n  /* box-shadow: 0px 0px 7px #005df0; */\r\n  /* margin: 3px -3px;\r\n  border-radius: 5px;\r\n  width: 102%; */\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  font-family: Jost !important;\r\n  color: #0a64f9;\r\n  white-space: nowrap;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data .view-hour-today-span {\r\n  width: 104px;\r\n}\r\n\r\n.modal-view-full-hours-description .full-hours-data .single-time-slot {\r\n  width: 48%;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data > div:nth-child(odd) {\r\n  /* background: #f9f9f9; */\r\n  display: flex;\r\n  align-items: start;\r\n  justify-content: space-between;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data > div > span {\r\n  text-transform: capitalize;\r\n  width: 100px;\r\n  text-align: center;\r\n  color: #232323;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n  /* border-right: 2px solid #c7c7c7; */\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data > div > p {\r\n  color: #000000;\r\n  font-size: 18px;\r\n  font-family: jost !important;\r\n  font-weight: 400;\r\n  text-align: center;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data > div > p > span {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.modal-view-full-hours-description\r\n  > .full-hours-data\r\n  > div\r\n  > p\r\n  > span.active-day-hour {\r\n  display: inline-block !important;\r\n  font-size: 14px;\r\n}\r\n\r\n.modal-view-full-hours-description > .full-hours-data-detail {\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n  padding-top: 15px;\r\n  margin-top: 10px;\r\n  width: 100%;\r\n  border-top: 2px solid #0000001a;\r\n}\r\n\r\n.modal-view-full-hours-description\r\n  > .full-hours-data-detail\r\n  > .single-full-hour-data-detail {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  /* justify-content: center; */\r\n  /* padding: 20px; */\r\n  width: 100%;\r\n}\r\n\r\n.full-hours-data-detail > .single-full-hour-data-detail > img {\r\n  margin-bottom: 15px;\r\n  width: 60px;\r\n  height: 60px;\r\n}\r\n\r\n.full-hours-data-detail > .single-full-hour-data-detail > p {\r\n  color: #232323;\r\n  font-size: 18px !important;\r\n  /* font-family: QuicksandBold !important; */\r\n  margin-left: 14px;\r\n  font-weight: 600;\r\n  font-family: Jost;\r\n}\r\n\r\n.full-hours-data-detail > .single-full-hour-data-detail > p > span {\r\n  color: #000000;\r\n  font-size: 18px !important;\r\n  /* font-family: QuicksandBold !important; */\r\n  line-height: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n/* end full hours modal*/\r\n/* End Single Store  */\r\n\r\n/* Start Store Wishlist */\r\n.quickvee-store-topbar-cart {\r\n  width: 450px;\r\n  background: #ffffff;\r\n}\r\n\r\n.quickvee-store-topbar-cart > .quickvee-store-cart-header {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n}\r\n\r\n.quickvee-store-topbar-cart > .quickvee-store-cart-header > h1 {\r\n  font-size: 24px;\r\n  font-family: QuicksandBold !important;\r\n  color: #222222;\r\n  text-align: center;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.quickvee-store-topbar-cart > .quickvee-store-cart-header > h1 > span {\r\n  font-size: 18px;\r\n  color: #595959;\r\n}\r\n\r\n.quickvee-store-topbar-cart > .quickvee-store-cart-header > Button {\r\n  padding: 5px !important;\r\n  background: #f3f3f3 !important;\r\n  min-width: 50px !important;\r\n}\r\n\r\n.quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-self: center;\r\n  position: absolute;\r\n  bottom: 0;\r\n  margin-bottom: 10px;\r\n  width: 100%;\r\n  padding: 0px 20px 0px 20px;\r\n}\r\n\r\n.delivery-amount-modal-cart .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\r\n  padding: 55px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.not-select-empty-delivery-content h1 {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 19px;\r\n  color: #232323;\r\n  margin-top: 15px;\r\n}\r\n\r\n.delivery-address-not-selected {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  width: 100%;\r\n  padding: 20px;\r\n}\r\n\r\n.delivery-amount-button-cart-ok {\r\n  margin-top: 10px;\r\n  align-self: center;\r\n  text-decoration: none;\r\n  text-align: center;\r\n  width: 150px;\r\n  background: #0a64f9;\r\n  padding: 10px 0;\r\n  border-radius: 6px;\r\n  color: #ffffff;\r\n  font-family: QuicksandBold !important;\r\n  font-size: 16px;\r\n  text-transform: capitalize !important;\r\n  cursor: pointer;\r\n  outline: none;\r\n  border: 1px solid #0a64f9;\r\n  margin: 20px;\r\n}\r\n\r\n.delivery-amount-modal-cart-text {\r\n  font-family: QuicksandBold !important;\r\n  font-size: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.quickvee-store-topbar-cart > .quickvee-store-cart-checkout-btn > a,\r\n.quickvee-store-topbar-cart\r\n  > .quickvee-store-cart-checkout-btn\r\n  > .payment-checkout-with-login,\r\n.quickvee-store-cart-checkout-btn .button-for-minamount-on-delivery {\r\n  text-decoration: none;\r\n  text-align: center;\r\n  width: 100%;\r\n  background: #000000;\r\n  padding: 13px 0px !important;\r\n  border-radius: 6px;\r\n  color: #ffffff;\r\n  font-family: QuicksandBold !important;\r\n  font-size: 16px;\r\n  text-transform: capitalize !important;\r\n  line-height: 1;\r\n  letter-spacing: normal;\r\n  height: 44px;\r\n}\r\n\r\n.quickvee-store-cart-checkout-btn .button-for-minamount-on-delivery:hover {\r\n  background: #0a64f9;\r\n}\r\n\r\n.quickvee-store-cart-items {\r\n  overflow-y: auto;\r\n  scroll-behavior: smooth;\r\n  /* margin: 10px 0; */\r\n  width: 100%;\r\n  height: 87vh;\r\n}\r\n\r\n/* width */\r\n.quickvee-store-cart-items::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n/* Track */\r\n.quickvee-store-cart-items::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Handle */\r\n.quickvee-store-cart-items::-webkit-scrollbar-thumb {\r\n  background: #3e85f8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease-in-out;\r\n  outline: 1px solid #fff;\r\n}\r\n\r\n/* Handle on hover */\r\n.quickvee-store-cart-items::-webkit-scrollbar-thumb:hover {\r\n  background: #0a64f9;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.quickvee-store-cart-items > .quickvee-store-cart-single-item {\r\n  padding: 17px 20px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  border-top: 1px solid #e1e1e1;\r\n  position: relative;\r\n}\r\n\r\n.quickvee-store-cart-items\r\n  > .quickvee-store-cart-single-item\r\n  > .quickvee-scsi-image {\r\n  border: 1px solid #e1e1e1;\r\n  padding: 10px;\r\n  height: 80px;\r\n}\r\n\r\n.quickvee-store-cart-items\r\n  > .quickvee-store-cart-single-item\r\n  > .quickvee-scsi-image {\r\n  object-fit: contain;\r\n}\r\n\r\n.quickvee-store-cart-items\r\n  > .quickvee-store-cart-single-item\r\n  > .quickvee-scsi-content {\r\n  width: 310px;\r\n  padding: 0px 10px 0px 17px;\r\n}\r\n\r\n.quickvee-store-cart-items\r\n  > .quickvee-store-cart-single-item\r\n  > .quickvee-scsi-content\r\n  > .q-cart-product-name {\r\n  width: 85%;\r\n  display: flex;\r\n  color: #212121;\r\n  font-size: 15px;\r\n  font-family: QuicksandMedium !important;\r\n  margin-bottom: 10px;\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n.quickvee-store-cart-items\r\n  > .quickvee-store-cart-single-item\r\n  > .quickvee-scsi-content\r\n  > p {\r\n  color: #232323;\r\n  font-family: QuicksandBold !important;\r\n  font-size: 12px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.quickvee-store-cart-items\r\n  > .quickvee-store-cart-single-item\r\n  > .quickvee-scsi-content\r\n  > p\r\n  > span {\r\n  color: #707070;\r\n  margin: 0 2px;\r\n}\r\n\r\n.q-cart-product-amount-section {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin: 2px 0;\r\n}\r\n\r\n.q-cart-product-amount-section > .q-cart-product-amount-calculation > span {\r\n  color: #2e2e2e;\r\n  font-family: QuicksandBold !important;\r\n  font-size: 20px;\r\n  margin: 0 4px;\r\n}\r\n\r\n.q-cart-product-amount-section > .q-cart-product-amount-calculation > del {\r\n  color: #989898;\r\n  font-family: QuicksandMedium !important;\r\n  font-size: 14px;\r\n  margin: 0 4px;\r\n}\r\n\r\n.q-cart-product-amount-update {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.q-cart-product-amount-section > .q-cart-product-amount-update > button {\r\n  color: #fff;\r\n  background: #0a64f9;\r\n  border-radius: 4px;\r\n  border: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px 6px 16px 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.q-cart-product-amount-section\r\n  > .q-cart-product-amount-update\r\n  > button:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n.q-cart-product-amount-section > .q-cart-product-amount-update > span {\r\n  color: #000000;\r\n  font-family: QuicksandSemibold !important;\r\n  font-size: 19px;\r\n  margin: 0 20px;\r\n  width: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.quickvee-scsi-content > .q-cart-product-customize {\r\n  float: right;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 13px 0;\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 15px;\r\n}\r\n\r\n.quickvee-scsi-content > .q-cart-product-customize > span {\r\n  color: #595959;\r\n  font-family: QuicksandBold !important;\r\n  font-size: 16px;\r\n  border-right: 2px solid #595959;\r\n  padding-right: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.quickvee-scsi-content > .q-cart-product-customize > img {\r\n  padding-left: 15px;\r\n  cursor: pointer;\r\n}\r\n\r\n.single-store-empty-cart {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  width: 100%;\r\n  height: 80vh;\r\n}\r\n\r\n.empty-cart-content {\r\n  /* width: 250px; */\r\n  height: 70vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.empty-cart-content img {\r\n  width: 80px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.empty-cart-content h1 {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 19px;\r\n  color: #232323;\r\n}\r\n\r\n.empty-cart-content p {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 13px;\r\n  color: #878787;\r\n  margin: 15px auto;\r\n}\r\n\r\n.empty-cart-content .continue-shopping-on-cart {\r\n  color: #0a64f9;\r\n  width: 200px;\r\n  border: 2px solid #0a64f9;\r\n  background: #fff;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n  text-transform: capitalize !important;\r\n  background: #ffffff;\r\n  border-radius: 5px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.continue-shopping-on-cart:hover {\r\n  background: #fff !important;\r\n}\r\n\r\n.continue-shopping-on-cart a {\r\n  text-decoration: none;\r\n  color: #0a64f9;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n/* End Store cart*/\r\n\r\n/*  start single product page */\r\n.quickvee-single-product-page {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px 0px;\r\n}\r\n\r\n.quickvee-single-product-top-section {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.quickvee-single-product-image-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 20px;\r\n  width: 45%;\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n\r\n.quickvee-single-product-image-section > .quickvee-single-product-main-image {\r\n  position: relative;\r\n  border: 1px solid #e1e1e1;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 60vh;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .quickvee-single-product-image-section > .quickvee-single-product-main-image {\r\n    height: unset;\r\n  }\r\n  .quickvee-single-product-main-image {\r\n    width: 100%;\r\n  }\r\n  .quickvee-single-product-main-image-skeleton {\r\n    width: 320px !important;\r\n  }\r\n}\r\n\r\n.quickvee-single-product-images {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  margin: 15px 0;\r\n}\r\n\r\n.quickvee-single-product-images .skeleton-for-loading {\r\n  display: flex;\r\n  margin-left: 10px;\r\n}\r\n\r\n.quickvee-single-product-images > .quickvee-single-product-images-single-image {\r\n  border: 1px solid #e1e1e1;\r\n  padding: 5px 10px;\r\n  margin: 0 9px 10px 0;\r\n  transition: all 0.5s ease-in-out;\r\n  cursor: pointer;\r\n}\r\n\r\n.quickvee-single-product-images\r\n  > .quickvee-single-product-images-single-image\r\n  > img {\r\n  width: 68px;\r\n}\r\n\r\n.quickvee-single-product-images\r\n  > .quickvee-single-product-images-single-image:hover {\r\n  border: 1px solid #232323;\r\n}\r\n\r\n.quickvee-single-product-image-section\r\n  > .quickvee-single-product-main-image\r\n  > span {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  /* background: #373737; */\r\n  padding: 10px 10px !important;\r\n  font-size: 17px;\r\n  font-family: QuicksandBold !important;\r\n  color: #ffffff;\r\n  align-self: flex-start;\r\n}\r\n\r\n.quickvee-single-product-image-section\r\n  > .quickvee-single-product-main-image\r\n  > .quickvee-single-product-add-to-wishlist-icon {\r\n  background: #efefef;\r\n  padding: 10px;\r\n  align-self: flex-start;\r\n  margin: 6px;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.quickvee-single-product-image-section\r\n  > .quickvee-single-product-main-image\r\n  > .quickvee-single-product-div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.quickvee-single-product-div img {\r\n  object-fit: cover;\r\n  object-position: center;\r\n  width: 90%;\r\n  height: 90%;\r\n}\r\n\r\n/* .quickvee-single-product-div  img:hover{\r\n\r\n} */\r\n.quickvee-single-product-detail-section {\r\n  width: 62%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 20px;\r\n}\r\n\r\n.quickvee-single-product-detail-section::-webkit-scrollbar {\r\n  width: 0px;\r\n}\r\n\r\n.quickvee-single-product-detail-section > .quickvee-single-product-main-detail {\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.quickvee-single-product-detail-section\r\n  > .quickvee-single-product-main-detail\r\n  > h1 {\r\n  color: #212121;\r\n  font-size: 22px;\r\n  font-family: QuicksandLight !important;\r\n}\r\n\r\n.quickvee-single-product-detail-section\r\n  > .quickvee-single-product-main-detail\r\n  > p\r\n  > span {\r\n  color: #2e2e2e;\r\n  font-size: 24px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\np.bogo-discount {\r\n  font-size: 15px;\r\n  font-family: QuicksandMedium !important;\r\n  margin: 8px 0px;\r\n}\r\n\r\n.quickvee-single-product-detail-section\r\n  > .quickvee-single-product-main-detail\r\n  > p\r\n  > del {\r\n  color: #989898;\r\n  font-size: 16px;\r\n  font-family: QuicksandMedium !important;\r\n}\r\n\r\n.quickvee-single-product-detail-section > .quickvee-single-product-features {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  width: 100%;\r\n}\r\n\r\n.quickvee-single-product-single-features {\r\n  margin: 5px 0;\r\n}\r\n\r\n.quickvee-single-product-single-features > p {\r\n  display: flex;\r\n  color: #232323;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.single-product-single-features-selection {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  margin: 0 0 12px 0;\r\n}\r\n\r\n.single-product-single-features-selection > div > input {\r\n  visibility: hidden;\r\n  width: 0px;\r\n  height: 45px;\r\n}\r\n\r\n.single-product-single-features-selection > div > input:checked + label {\r\n  color: #0a64f9;\r\n  background: #ffffff;\r\n  box-shadow: 0px 0px 9px #0a64f94d;\r\n  border: 1px solid #176cf8;\r\n  border-radius: 4px;\r\n  height: 44px;\r\n}\r\n\r\n.single-product-single-features-selection > div > label {\r\n  cursor: pointer;\r\n  color: #434343;\r\n  text-transform: capitalize;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemibold !important;\r\n  background: #efefef 0% 0% no-repeat padding-box;\r\n  border-radius: 4px;\r\n  padding: 10px 14px;\r\n  margin: 8px 15px 8px 0;\r\n  border: 1px solid #efefef00;\r\n  height: 44px;\r\n}\r\n\r\n.quickvee-single-product-add-update {\r\n  display: flex;\r\n  margin: 20px 0;\r\n}\r\n\r\n.quickvee-single-product-add-update > button {\r\n  background: #0a64f9;\r\n  border-radius: 4px;\r\n  color: #fff;\r\n  padding: 0px 8px !important;\r\n  border: none;\r\n  cursor: pointer;\r\n  height: 44px;\r\n}\r\n\r\n.quickvee-single-product-add-update .add-minuus-button {\r\n  display: flex;\r\n  padding: 12px !important;\r\n}\r\n\r\n/* .quickvee-single-product-add-update .add-minuus-button img{\r\n  width: 20px;\r\n} */\r\n.quickvee-single-product-add-update > button:disabled {\r\n  opacity: 0.5;\r\n  cursor: auto;\r\n}\r\n\r\n.quickvee-single-product-add-update > span {\r\n  margin: 5px 15px;\r\n  width: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 20px;\r\n}\r\n\r\n.quickvee-single-product-add-update > .single-patc-btn,\r\n.quickvee-single-product-add-update > .single-patc-btn:hover {\r\n  background: #232323;\r\n  border-radius: 4px;\r\n  color: #ffffff;\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 14px !important;\r\n  padding: 5px 20px !important;\r\n  text-transform: capitalize !important;\r\n  margin: 0 20px;\r\n}\r\n\r\n.quickvee-single-product-add-update > .single-patc-btn:disabled {\r\n  color: #fff;\r\n  cursor: not-allowed;\r\n  pointer-events: all;\r\n}\r\n\r\n.go-to-cart-btn,\r\n.go-to-cart-btn:hover {\r\n  width: 50%;\r\n  background: #232323 !important;\r\n  border-radius: 4px !important;\r\n  color: #ffffff !important;\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 14px !important;\r\n  padding: 7.76px 20px !important;\r\n  text-transform: capitalize !important;\r\n  margin: 20px 0 !important;\r\n  height: 44px;\r\n}\r\n\r\n.quickvee-single-product-detail-description > span {\r\n  color: #232323;\r\n  font-size: 20px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-product-detail-description > p {\r\n  margin: 10px 0;\r\n  font-family: QuicksandMedium !important;\r\n  text-align: justify;\r\n}\r\n\r\n.quickvee-single-product-detail-description > ul {\r\n  padding: 0 20px;\r\n  font-family: QuicksandMedium !important;\r\n  text-align: justify;\r\n}\r\n\r\n.quickvee-single-product-detail-description > ul > li {\r\n  list-style: none;\r\n}\r\n\r\n.quickvee-single-product-detail-description > ul li::before {\r\n  content: '\\2022';\r\n  color: #232323;\r\n  font-weight: bold;\r\n  display: inline-block;\r\n  width: 1em;\r\n  margin-left: -1em;\r\n}\r\n\r\n.quickvee-single-product-bottom-section {\r\n  margin: 0 0 20px 0;\r\n}\r\n\r\n.quickvee-single-product-bottom-section > span {\r\n  color: #232323;\r\n  font-size: 20px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-single-product-bottom-content-section {\r\n  border: 1px solid #dcdcdc;\r\n  display: flex;\r\n  flex-direction: column;\r\n  /* align-items: center; */\r\n  justify-content: flex-start;\r\n  margin: 10px 0;\r\n}\r\n\r\n.fbt-products {\r\n  display: flex;\r\n  padding: 20px;\r\n  align-items: center;\r\n}\r\n\r\n.fbt-single-product-div {\r\n  width: 100%;\r\n}\r\n\r\n.fbt-single-product-div\r\n  > .fbt-single-product\r\n  > .fbt-single-product-content\r\n  > span {\r\n  color: #212121;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.fbt-single-product-div\r\n  > .fbt-single-product\r\n  > .fbt-single-product-content\r\n  > p {\r\n  color: #2e2e2e;\r\n  font-size: 17px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.fbt-single-product-div\r\n  > .fbt-single-product\r\n  > .fbt-single-product-content\r\n  > p\r\n  > del {\r\n  color: #989898;\r\n  font-size: 13px;\r\n  font-family: QuicksandMedium !important;\r\n}\r\n\r\n.fbt-single-product-div > .fbt-single-product {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  background: #ffffff;\r\n  border-radius: 4px;\r\n  border: 1px solid #2ccb61;\r\n}\r\n\r\n.fbt-single-product-div > .fbt-single-product > .fbt-single-product-content {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  flex-direction: column;\r\n  margin-left: 10px;\r\n  width: 80%;\r\n}\r\n\r\n.quickvee-single-product-bottom-content-section\r\n  > .fbt-products\r\n  > .fbt-single-product-div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.fbt-category-selected-items > div {\r\n  font-size: 14px !important;\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n.fbt-category-selected-items\r\n  .css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input.css-d9oaum-MuiSelect-select-MuiInputBase-input-MuiFilledInput-input {\r\n  padding: 20px 10px 3px 9px !important;\r\n}\r\n\r\n.fbt-category-item {\r\n  font-size: 14px !important;\r\n}\r\n\r\n.fbt-category-label > label {\r\n  color: #232323 !important;\r\n  font-size: 14px !important;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n.quickvee-single-product-bottom-content-section > .fbt-products-amount {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: #f9f9f9;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.fbt-products-plus-product-div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 34%;\r\n}\r\n\r\n.fbt-single-product-div > .fbt-single-product-features > div {\r\n  margin: 10px 0;\r\n}\r\n\r\n.quickvee-single-product-bottom-content-section > .fbt-products-amount > p {\r\n  font-family: QuicksandRegular !important;\r\n  font-size: 20px;\r\n}\r\n\r\n.quickvee-single-product-bottom-content-section\r\n  > .fbt-products-amount\r\n  > Button {\r\n  background: #0a64f9 !important;\r\n  border-radius: 4px;\r\n  font-size: 15px;\r\n  font-family: QuicksandSemiBold !important;\r\n  text-transform: capitalize;\r\n  color: #fff;\r\n  padding: 4px 13px !important;\r\n}\r\n\r\n.quickvee-highest-selling-product-section {\r\n  width: 100%;\r\n  height: auto;\r\n  display: inline-block;\r\n}\r\n\r\n.quickvee-highest-selling-product-section > span {\r\n  color: #232323;\r\n  font-size: 20px;\r\n  font-family: QuicksandBold !important;\r\n  line-height: 55px;\r\n}\r\n\r\n.quickvee-highest-selling-products {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex-wrap: wrap;\r\n  margin: 15px 0;\r\n}\r\n\r\n/*  end  single product page */\r\n\r\n/* start Single Product */\r\n\r\n.q-sv-single-product {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 300px;\r\n  background: #ffffff;\r\n  border: 1px solid #e5e5e5;\r\n  border-radius: 5px;\r\n  padding: 10px;\r\n  transition: all 0.4s ease-in-out;\r\n  /* margin: 0px 30px 25px 0px; */\r\n  justify-content: space-between;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.slick-slider {\r\n  margin: 0 -15px;\r\n}\r\n\r\n.slick-initialized .slick-slide {\r\n  padding-right: 20px;\r\n  padding-left: 20px;\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .q-sv-single-product:hover {\r\n    box-shadow: 0px 8px 22px #00000017;\r\n    border: 1px solid #c6c6c6;\r\n    border-radius: 5px;\r\n\r\n    /* height: 290px; */\r\n  }\r\n}\r\n\r\n.q-sv-single-product > .q-sv-single-product-top {\r\n  outline: none;\r\n  width: 200px;\r\n  height: 150px;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* margin-bottom: 20px; */\r\n  align-self: center;\r\n}\r\n\r\n.discout-tag {\r\n  z-index: 2;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 28px;\r\n  border-radius: 4px 0px;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-family: QuicksandBold !important;\r\n  padding: 5px 10px;\r\n  align-self: flex-start;\r\n}\r\n\r\nspan.limited-qty-text {\r\n  color: red;\r\n  z-index: 2;\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 10px;\r\n  font-size: 14px;\r\n  font-family: QuicksandBold !important;\r\n  width: auto !important;\r\n}\r\n\r\nspan.limited-quantity-text {\r\n  color: red;\r\n  font-size: 16px;\r\n  font-family: QuicksandBold !important;\r\n  width: auto !important;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .discout-tag-mobile {\r\n    display: none;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .discout-tag {\r\n    display: none;\r\n  }\r\n  span.limited-qty-text {\r\n    margin-bottom: 6px;\r\n  }\r\n}\r\n.discout-tag-mobile {\r\n  z-index: 2;\r\n  /* position: absolute; */\r\n  /* top: 0px;\r\n  left: 0px; */\r\n  /* height: 18px; */\r\n  border-radius: 0px;\r\n  color: #ffffff;\r\n  font-size: 12px;\r\n  font-family: QuicksandBold !important;\r\n  padding: 2px 7px;\r\n  align-self: flex-start;\r\n}\r\n.q-sv-single-product > .q-sv-single-product-top > img {\r\n  z-index: 1;\r\n  height: 100%;\r\n  /* width: 140px; */\r\n  transition: all 0.4s ease-in-out;\r\n}\r\n\r\n/* .q-sv-single-product:hover>.q-sv-single-product-top>img {\r\n  height: 100%;\r\n  width: 100%;\r\n} */\r\n\r\n.q-sv-single-product > .q-sv-single-product-bottom {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.q-sv-single-product > .q-sv-single-product-bottom > h1 {\r\n  color: #212121;\r\n  font-size: 14px;\r\n  font-family: QuicksandMedium !important;\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n/* @media (max-width:768px) { */\r\n.single-product-card-heading {\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n  /* height: 30px; */\n}\n\n.single-product-card-title-link {\n  width: 100%;\n  display: block;\n  border-radius: 4px;\n  color: inherit;\n  text-decoration: none;\n}\n\n.single-product-card-title-link:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.24);\n  outline-offset: 2px;\n}\n/* } */\r\n\r\n@media (max-width: 768px) {\r\n  .single-product-card-heading {\r\n    height: 30px;\r\n  }\r\n}\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-amount {\r\n  margin: 4px 0;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-amount\r\n  > span {\r\n  color: #0a64f9;\r\n  font-size: 18px;\r\n  font-family: QuicksandBold !important;\r\n  margin-right: 10px;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-amount\r\n  > del {\r\n  color: #888888;\r\n  font-size: 14px;\r\n  font-family: QuicksandMedium !important;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > Button {\r\n  width: 75%;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  /* justify-content: space-around !important; */\r\n  background: #0a64f9;\r\n  border-radius: 4px;\r\n  color: #ffffff;\r\n  /* font-size: 14px; */\r\n  font-size: clamp(10px, 0.05px + 2.6783vw, 14px) !important;\r\n  font-family: QuicksandMedium !important;\r\n  text-transform: capitalize !important;\r\n  padding: 6px 8px 6px 8px;\r\n  height: 37px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 44px;\r\n}\r\n@media (min-width: 806px) and (max-width: 822px) {\r\n  .q-sv-single-product\r\n    > .q-sv-single-product-bottom\r\n    > .q-sv-single-product-bottom-purchase\r\n    > Button {\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > Button\r\n  p {\r\n  /* margin-left: 5%; */\r\n  white-space: nowrap;\r\n  /* font-size: clamp(12px, 0.1px + 0.98783vw, 14px) !important; */\r\n  font-size: 14px;\r\n}\r\n\r\n.q-sv-single-product .out-of-stock-btn {\r\n  background-color: rgb(255, 255, 255) !important;\r\n  color: red !important;\r\n  border: 1px solid red;\r\n}\r\n\r\n.out-of-stock-btn-single-product-page {\r\n  margin: 24px 0 !important;\r\n  width: 55%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-around;\r\n  background-color: rgb(255, 255, 255) !important;\r\n  color: red !important;\r\n  border: 1px solid red !important;\r\n  border-radius: 4px;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  font-family: QuicksandMedium !important;\r\n  text-transform: capitalize !important;\r\n  height: 44px !important;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > .remove-wish {\r\n  background: #fff5f5;\r\n  border-radius: 4px;\r\n  padding: 7px 9px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.remove-wish img {\r\n  width: 20px;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > .add-wish {\r\n  display: flex;\r\n  background: #eef4ff;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  height: 44px;\r\n  position: relative;\r\n  width: 38px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .q-sv-single-product\r\n    > .q-sv-single-product-bottom\r\n    > .q-sv-single-product-bottom-purchase\r\n    > .add-wish {\r\n    margin-top: 5px;\r\n  }\r\n}\r\n\r\n.q-sv-single-product .single-p-select-variant-btn {\n  width: 75%;\r\n  color: #000000;\r\n  border: 1px solid #000000;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  /* font-size: 14px; */\r\n  font-size: clamp(10px, 0.05px + 2.6783vw, 14px) !important;\r\n  font-family: QuicksandMedium !important;\r\n  border-radius: 4px;\r\n  padding: 8px 0px;\r\n  text-align: center;\r\n  height: 37px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\n  height: 44px;\n  cursor: pointer;\n}\n\n.q-sv-single-product .single-p-select-variant-btn:focus-visible {\n  outline: 3px solid rgba(10, 100, 249, 0.24);\n  outline-offset: 2px;\n}\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > .product-qti-button {\r\n  color: #000;\r\n  display: flex;\r\n  align-items: center !important;\r\n  justify-content: space-between !important;\r\n  cursor: auto;\r\n  background: #fff !important;\r\n  border-radius: 4px;\r\n  width: 75%;\r\n  padding: 7px;\r\n  height: 44px;\r\n  border: 1px solid #000;\r\n}\r\n\r\n.product-qti-button .css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\r\n  color: #fff;\r\n}\r\n\r\n.q-sv-single-product-bottom-purchase\r\n  > .product-qti-button\r\n  > .add-remove-cart-btn {\r\n  background: #000 !important;\r\n  width: auto !important;\r\n  padding: 4px 5px !important;\r\n  box-shadow: none !important;\r\n  min-width: unset !important;\r\n  border: 1px solid #000 !important;\r\n  height: 28px;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > .product-qti-button\r\n  > svg {\r\n  cursor: pointer;\r\n}\r\n\r\n.q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > .product-qti-button\r\n  > span {\r\n  font-size: 16px;\r\n  font-family: QuicksandMedium !important;\r\n  color: #000000;\r\n}\r\n\r\n/* end single product*/\r\n\r\n/* Start Featured categories */\r\n.single-store-featured-categories-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.single-store-featured-categories-section > h1 {\r\n  color: #212121;\r\n  font-size: 26px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.single-store-featured-categories-section > .all-featured-categories {\r\n  margin: 10px 0;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.featured-categories-scrollable-row {\r\n  display: flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.single-featured-category {\r\n  text-decoration: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  margin-right: 10px;\r\n  width: 250px;\r\n  height: 60px;\r\n  scroll-snap-align: start;\r\n  touch-action: pan-y;\r\n}\r\n\r\n.single-featured-category > img {\r\n  width: 45px;\r\n  object-fit: contain;\r\n}\r\n\r\n.single-featured-category > .single-featured-category-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  padding: 0 0 0 10px;\r\n  min-width: 100px;\r\n}\r\n\r\n.single-featured-category > .single-featured-category-content > span {\r\n  color: #212121;\r\n  font-size: 12px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.single-featured-category > .single-featured-category-content > p {\r\n  color: #212121;\r\n  font-family: QuicksandRegular !important;\r\n  font-size: 11px;\r\n}\r\n\r\n.quickvee-highest-selling-product-section .slick-slider .slick-prev {\r\n  right: 55px;\r\n  top: -32px;\r\n}\r\n\r\n.quickvee-highest-selling-product-section .slick-slider .slick-next {\r\n  right: 16px;\r\n  top: -32px;\r\n}\r\n\r\n/* End Featured categories */\r\n\r\n/*  Start SingleStoreAllInformationPage */\r\n.SingleStoreAllInformationPage {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  /* overflow: hidden; */\r\n}\r\n\r\n.single-store-banners-images {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.single-store-banners-images > a {\r\n  margin: 10px 10px 10px 0;\r\n  width: 35%;\r\n}\r\n\r\n.single-store-banners-images > a > img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.single-store-sproductListing-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.single-store-sproductListing-section > section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  margin: 0px 0px 0px 0;\r\n}\r\n\r\n.single-store-sproductListing-section > section > div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  /* width: 200px; */\r\n}\r\n\r\n.single-store-sproductListing-section > section > div > a {\r\n  color: #0a64f9;\r\n  font-size: 17px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.single-store-sproductListing-section\r\n  > section\r\n  > div\r\n  > .search-category-store-image-div {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100px;\r\n}\r\n\r\n/* .single-store-sproductListing-section>section> div > div  > img{\r\n  cursor: pointer;\r\n} */\r\n\r\n.slick-next {\r\n  right: 95px;\r\n  top: -20px;\r\n  z-index: 1;\r\n  /* background: black; */\r\n  width: 31px;\r\n  height: 27px;\r\n}\r\n\r\n.slick-next.slick-disabled:before {\r\n  cursor: default !important;\r\n\r\n  opacity: 1;\r\n  content: url('../Assets/Store/ScrollRight.svg') !important;\r\n}\r\n\r\n.slick-next:before {\r\n  opacity: 1;\r\n  content: url('../Assets/Store/HoverScrollRight.svg') !important;\r\n}\r\n\r\n.slick-prev {\r\n  right: 133px;\r\n  left: unset !important;\r\n  top: -20px;\r\n  width: 31px;\r\n  height: 27px;\r\n}\r\n\r\n.slick-prev.slick-disabled:before {\r\n  cursor: default !important;\r\n  opacity: 1;\r\n  content: url('../Assets/Store/ScrollLeft.svg') !important;\r\n}\r\n\r\n.slick-prev:before {\r\n  opacity: 1;\r\n  content: url('../Assets/Store/HoverScrollLeft.svg') !important;\r\n}\r\n\r\n.single-store-sproductListing-section > section > span {\r\n  color: #212121;\r\n  font-size: 24px;\r\n\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n@media (max-width: 820px) {\r\n  .single-store-sproductListing-section > section > span {\r\n    font-size: clamp(22px, 0.05px + 2.1783vw, 24px) !important;\r\n  }\r\n}\r\n\r\n.single-store-sproductListing-section > .single-store-sproductListing-products,\r\n.slick-slider .slick-initialized {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  width: 100%;\r\n  user-select: none;\r\n  /* flex-wrap: wrap; */\r\n}\r\n\r\n.single-store-single-category-product-listing-section {\r\n  /* margin: 0px 5px; */\r\n  min-height: calc(100vh - 137px) !important;\r\n}\r\n\r\n.single-store-single-category-product-listing {\r\n  /* width: 100%; */\r\n  /* display: flex; */\r\n  /* flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: flex-start; */\r\n  margin: 10px -15px;\r\n  /* display: inline-block; */\r\n}\r\n\r\n.single-store-single-category-product-listing.loading {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  /* min-height: calc(100vh - 137px) !important;  */\r\n}\r\n\r\n.product-in-category {\r\n  width: 20%;\r\n  padding-left: 15px;\r\n  display: inline-block;\r\n  padding-right: 15px;\r\n  float: left;\r\n}\r\n\r\n.single-selectCategory-product-listing > .q-single-category-headings {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 0;\r\n  position: relative;\r\n}\r\n\r\n.single-selectCategory-product-listing > .q-single-category-headings > span {\r\n  color: #212121;\r\n  font-size: 24px;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.select-box {\r\n  position: absolute;\r\n  right: 0px;\r\n  display: block;\r\n  width: 230px;\r\n  margin: 0 auto;\r\n  font-family: QuicksandMedium, sans-serif !important;\r\n  font-size: 18px;\r\n  color: #000000;\r\n  z-index: 1;\r\n}\r\n\r\n.select-box__current {\r\n  position: relative;\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n\r\n.select-box__current:focus + .select-box__list {\r\n  opacity: 1;\r\n  -webkit-animation-name: none;\r\n  animation-name: none;\r\n}\r\n\r\n.select-box__current:focus + .select-box__list .select-box__option {\r\n  cursor: pointer;\r\n}\r\n\r\n.select-box__current .select-box__icon {\r\n  /* transform: translateY(-50%) rotate(180deg); */\r\n}\r\n\r\n.select-box__current:focus .select-box__icon {\r\n  transform: translateY(-50%) rotate(0deg);\r\n}\r\n\r\n.select-box__icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 15px;\r\n  transform: translateY(-50%);\r\n  width: 20px;\r\n  opacity: 1;\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.select-box__value {\r\n  display: flex;\r\n}\r\n\r\n.select-box__input {\r\n  display: none;\r\n}\r\n\r\n.select-box__input:checked + .select-box__input-text {\r\n  display: block;\r\n  /* border: 1px solid #000000; */\r\n  border-radius: 7px;\r\n  font-size: 16px;\r\n}\r\n\r\n.select-box__input-text {\r\n  display: none;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 10px;\r\n  background-color: #fff;\r\n  text-align: end;\r\n  padding-right: 48px;\r\n}\r\n\r\n.select-box__list {\r\n  z-index: -1;\r\n  overflow: hidden;\r\n  /* border: 1px solid #707070; */\r\n  /* border-radius: 7px 7px 7px 7px; */\r\n  border-radius: 8px;\r\n  box-shadow: 0px 6px 15px #0a64f94d;\r\n  position: absolute;\r\n  top: 38 px;\r\n  width: 100%;\r\n  padding: 0;\r\n  list-style: none;\r\n  opacity: 0;\r\n  -webkit-animation-name: HideList;\r\n  animation-name: HideList;\r\n  -webkit-animation-duration: 0.5s;\r\n  animation-duration: 0.5s;\r\n  -webkit-animation-delay: 0.5s;\r\n  animation-delay: 0.5s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-timing-function: step-start;\r\n  animation-timing-function: step-start;\r\n  background: #ffffff 0% 0% no-repeat padding-box;\r\n}\r\n\r\n.select-box__option {\r\n  font-size: 16px;\r\n  font-family: QuicksandMedium !important;\r\n  color: #414141;\r\n  display: block;\r\n  padding: 10px 15px;\r\n  background-color: #fff;\r\n}\r\n\r\n.select-box__option:hover,\r\n.select-box__option:focus {\r\n  color: #000000;\r\n  background-color: #fbfbfb;\r\n}\r\n\r\n.sort-by:hover,\r\n.sort-by:focus {\r\n  color: #414141 !important;\r\n  background-color: #fbfbfb;\r\n  cursor: auto !important;\r\n}\r\n\r\n@-webkit-keyframes HideList {\r\n  from {\r\n    transform: scaleY(1);\r\n  }\r\n\r\n  to {\r\n    transform: scaleY(0);\r\n  }\r\n}\r\n\r\n@keyframes HideList {\r\n  from {\r\n    transform: scaleY(1);\r\n  }\r\n\r\n  to {\r\n    transform: scaleY(0);\r\n  }\r\n}\r\n\r\n/*  End SingleStoreAllInformationPage */\r\n\r\n/* Start Wishlist */\r\n.single-store-wishlist {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* .single-store-wishlist div {\r\n  margin-right: 26px;\r\n  width: 242px;\r\n} */\r\n\r\n/* .single-store-wishlist\r\n  > .q-sv-single-product\r\n  > .q-sv-single-product-bottom\r\n  > .q-sv-single-product-bottom-purchase\r\n  > .add-wish {\r\n  right: 19px;\r\n  height: 37px;\r\n} */\r\n\r\n.single-store-empty-wishlist {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  width: 100%;\r\n  height: 80vh;\r\n}\r\n\r\n.empty-wishlist-content {\r\n  width: 300px;\r\n  height: 70vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.empty-wishlist-content img {\r\n  width: 80px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.empty-wishlist-content h1 {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 19px;\r\n  color: #232323;\r\n}\r\n\r\n.empty-wishlist-content p {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 13px;\r\n  color: #878787;\r\n  margin: 15px auto;\r\n  margin-bottom: 15px !important;\r\n}\r\n\r\n.empty-wishlist-content .continue-shopping-on-wishlist {\r\n  color: #0a64f9;\r\n  width: 200px;\r\n  border: 2px solid #0a64f9;\r\n  background: #fff;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n  text-transform: capitalize !important;\r\n  background: #ffffff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.continue-shopping-on-wishlist:hover {\r\n  background: #fff !important;\r\n}\r\n\r\n.continue-shopping-on-wishlist a {\r\n  text-decoration: none;\r\n  color: #0a64f9;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n/* End Wishlist */\r\n\r\n/* Start Wishlist */\r\n.single-store-loyalty-point {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.single-store-empty-loyalty-point {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  width: 100%;\r\n  height: 55vh;\r\n}\r\n\r\n.empty-loyalty-point-content {\r\n  /* width: 300px; */\r\n  /* height: 70vh; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.empty-loyalty-point-content img {\r\n  width: 80px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.empty-loyalty-point-content h1 {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 19px;\r\n  color: #232323;\r\n}\r\n\r\n.empty-loyalty-point-content p {\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 13px;\r\n  color: #878787;\r\n  margin: 15px auto;\r\n  margin-bottom: 15px !important;\r\n}\r\n\r\n.empty-loyalty-point-content .continue-shopping-on-loyalty-point {\r\n  color: #0a64f9;\r\n  width: 200px;\r\n  border: 2px solid #0a64f9;\r\n  background: #fff;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n  text-transform: capitalize !important;\r\n  background: #ffffff;\r\n  border-radius: 5px;\r\n}\r\n\r\n.continue-shopping-on-loyalty-point:hover {\r\n  background: #fff !important;\r\n}\r\n\r\n.continue-shopping-on-loyalty-point a {\r\n  text-decoration: none;\r\n  color: #0a64f9;\r\n  font-size: 14px;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n/* End Wishlist */\r\n\r\n/* Start HomePage */\r\n.home-page-all-sections {\r\n  min-height: calc(100vh - 120px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  width: 80%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.home-page-all-sections > div {\r\n  margin: 10px auto;\r\n  width: 100%;\r\n}\r\n\r\n.home-categories {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  margin-top: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.single-home-categorie {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin: 0 10px;\r\n}\r\n\r\n.single-home-categorie > .single-home-categorie-image-section {\r\n  height: 100px;\r\n  width: 100px;\r\n  border: 1px solid #eee;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  margin: 0 auto;\r\n  /* background-color: red; */\r\n}\r\n\r\n.single-home-categorie > span {\r\n  justify-content: center;\r\n  text-align: center;\r\n  margin: 8px 0 0 0;\r\n  font-family: QuicksandMedium !important;\r\n  font-size: 16px;\r\n  color: #131313;\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 2;\r\n  overflow: hidden;\r\n}\r\n\r\n.quickvee-home-stores {\r\n  margin: 20px auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.quickvee-home-stores > h1 {\r\n  font-size: 24px;\r\n  color: #212121;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.quickvee-home-all-stores {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  text-align: center;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.quickvee-home-single-store {\r\n  margin: 20px auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n@media (min-width: 1000px) {\r\n  .quickvee-home-single-store {\r\n    width: 21%;\r\n    margin: 2%;\r\n    display: flex;\r\n    align-self: flex-start;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.quickvee-home-single-store > a {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n}\r\n\r\n.q-store-image-section {\r\n  position: relative;\r\n  border: 2px solid #f2f2f2;\r\n  width: 130px;\r\n  height: 130px;\r\n  border-radius: 100px;\r\n  overflow: hidden;\r\n  text-align: center;\r\n}\r\n\r\n.q-store-image-section img {\r\n  width: 90%;\r\n  height: auto;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  padding: 10px;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.q-store-content-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-self: center;\r\n  text-align: center;\r\n  width: 238px;\r\n}\r\n\r\n.q-store-content-section > span {\r\n  margin-top: 10px;\r\n  /* font-size: 18px; */\r\n  font-size: clamp(16px, 0.05px + 2.6783vw, 18px) !important;\r\n  color: #232323;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.q-store-content-section > p {\r\n  font-size: 13px;\r\n  color: #232323;\r\n  font-family: QuicksandMedium !important;\r\n}\r\n\r\n.quicvee-home-banner {\r\n  margin: 40px 0;\r\n  width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.quicvee-home-banner > .quickvee-home-banner-image {\r\n  height: auto;\r\n  width: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n/*  search box  */\r\n\r\n.search-data-box::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n/* Track */\r\n.search-data-box::-webkit-scrollbar-track {\r\n  background-color: #fff;\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Handle */\r\n.search-data-box::-webkit-scrollbar-thumb {\r\n  background: #3e85f8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease-in-out;\r\n  outline: 1px solid #fff;\r\n}\r\n\r\n/* Handle on hover */\r\n.search-data-box::-webkit-scrollbar-thumb:hover {\r\n  background: #0a64f9;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.search-data-box {\r\n  z-index: 5;\r\n  left: 250px;\r\n  top: 55px;\r\n  width: 50vw;\r\n  overflow-y: auto;\r\n  position: absolute;\r\n  height: auto;\r\n  background: #ffffff;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 6px 15px #0a64f94d;\r\n  max-height: 473px;\r\n  overflow-x: hidden;\r\n  padding: 5px 0px;\r\n}\r\n\r\n.search-data-box > a {\r\n  display: block;\r\n  width: 100%;\r\n  /* border-bottom: 1px solid #E1E1E1; */\r\n  padding: 10px 10px;\r\n}\r\n\r\n.search-bar-link {\r\n  /* font-family: QuicksandMedium !important; */\r\n  /* width: 100%; */\r\n  color: #202020 !important;\r\n  font-size: 14px;\r\n  padding-inline: 10px;\r\n}\r\n\r\n.search-bar-link:visited {\r\n  color: #202020 !important;\r\n}\r\n\r\n.online-o-page-profile-box {\r\n  text-align: start;\r\n  z-index: 5;\r\n  right: 110px;\r\n  top: 50px;\r\n  width: 140px;\r\n  position: absolute;\r\n  height: auto;\r\n  background: #ffffff 0% 0% no-repeat padding-box;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 6px 15px #0a64f94d;\r\n  padding: 5px;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  right: 0;\r\n  margin-right: 2%;\r\n  bottom: 0;\r\n  display: inline-table;\r\n}\r\n\r\n.online-o-page-profile-box > .profile-bar-link {\r\n  text-align: start;\r\n  text-decoration: none !important;\r\n  font-family: QuicksandMedium !important;\r\n  width: 100%;\r\n  color: #000000 !important;\r\n  font-size: 14px;\r\n  padding: 7px;\r\n  display: block;\r\n}\r\n\r\n.online-o-page-profile-box > .profile-bar-link-logout {\r\n  text-transform: capitalize;\r\n  font-family: QuicksandMedium !important;\r\n  /* margin-left: -31px; */\r\n}\r\n\r\n.online-o-page-profile-box > .profile-bar-link-logout:hover {\r\n  background: none !important;\r\n}\r\n\r\n.online-o-page-profile-box > .profile-bar-link:nth-child(0) {\r\n  border-bottom: 1px solid #e1e1e1;\r\n}\r\n\r\n.online-o-page-profile-box > .profile-bar-link:nth-child(1) {\r\n  border-bottom: 1px solid #e1e1e1;\r\n}\r\n\r\n.online-o-page-profile-box > .profile-bar-link:nth-child(2) {\r\n  border-bottom: 1px solid #e1e1e1;\r\n}\r\n\r\n.top-bar-button:hover {\r\n  background: none !important;\r\n}\r\n\r\n/* End Homepage */\r\n\r\n/* Start Footer */\r\n.footer_area {\r\n  width: 100%;\r\n  height: auto;\r\n  background: #f6f6f6;\r\n  padding: 10px 0;\r\n  float: left;\r\n  margin-top: 20px;\r\n}\r\n\r\n.footer_area_inner {\r\n  width: 74%;\r\n  height: auto;\r\n  margin: 0 auto;\r\n}\r\n\r\n.footer_area_inner.footer_area_inner_menu {\r\n  width: 100%;\r\n  height: auto;\r\n  padding-left: 18%;\r\n  padding-right: 2%;\r\n  display: inline-block;\r\n}\r\n\r\n.footer_areaL {\r\n  width: 40%;\r\n  height: auto;\r\n  float: left;\r\n}\r\n\r\n.footer_areaL p {\r\n  display: inline-block;\r\n  font-size: 12px;\r\n  color: #707070;\r\n  font-family: 'QuicksandMedium';\r\n}\r\n\r\n.footer_areaR {\r\n  width: 60%;\r\n  height: auto;\r\n  float: left;\r\n}\r\n\r\n.footer_areaR ul {\r\n  list-style: none;\r\n  float: right;\r\n  padding: 0px;\r\n}\r\n\r\n.footer_areaR ul li {\r\n  float: left;\r\n  padding: 0 10px;\r\n  border-right: 1px solid #707070;\r\n  display: inline-block;\r\n}\r\n\r\n.footer_areaR ul li:last-child {\r\n  border-right: none;\r\n  padding-right: 0px;\r\n}\r\n\r\n.footer_areaR ul li a {\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 12px;\r\n  color: #707070;\r\n  font-family: 'QuicksandMedium';\r\n}\r\n\r\n.footer_areaR ul li a:hover {\r\n  color: #0a64f9;\r\n}\r\n\r\n/* End Footer */\r\n\r\n/* Start Header*/\r\n\r\n.header_area {\r\n  width: 100%;\r\n  height: auto;\r\n  background: #fff;\r\n  border-bottom: 1px solid #e6e6e6;\r\n  padding: 10px 0;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 99;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.quickvee_logo {\r\n  width: 148px;\r\n  height: 44px;\r\n}\r\n\r\n.header_area_box {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 80%;\r\n  height: auto;\r\n  margin: 0 auto;\r\n}\r\n\r\n.header_area_box > .other-header-items {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-left: auto;\r\n}\r\n\r\n.logo_area {\r\n  width: auto;\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.home_page_top_category_div {\r\n  /* width: 173px !important; */\r\n  height: auto;\r\n  padding: 0 10px;\r\n  text-align: center;\r\n}\r\n\r\n.home_page_top_category_div > .q-single-category-link-home {\r\n  text-decoration: none !important;\r\n  display: inline-block;\r\n}\r\n\r\n.q-single-category-link-home > span {\r\n  text-decoration: none !important;\r\n  display: inline-block;\r\n  color: #000 !important;\r\n  margin-top: 10px;\r\n  font-family: QuicksandMedium !important;\r\n}\r\n\r\n.home_page_top_category_div_inner {\r\n  width: 100px;\r\n  height: 100px;\r\n  border: 1px solid #eee;\r\n  border-radius: 100px;\r\n  overflow: hidden;\r\n  margin: 0 auto;\r\n}\r\n\r\n.home_page_top_category_div_inner img {\r\n  width: 100%;\r\n}\r\n\r\n.links-div {\r\n  position: relative;\r\n}\r\n\r\n.home-page-link-box {\r\n  z-index: 5;\r\n  left: 0px;\r\n  /* top: 50px; */\r\n  width: 130px;\r\n  position: absolute;\r\n  height: auto;\r\n  background: #ffffff 0% 0% no-repeat padding-box;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 6px 15px #0a64f94d;\r\n  padding: 5px;\r\n  flex-direction: column;\r\n}\r\n\r\n.home-page-link-box > .profile-bar-link {\r\n  text-decoration: none !important;\r\n  font-family: QuicksandMedium !important;\r\n  width: 100%;\r\n  color: #000000 !important;\r\n  font-size: 14px;\r\n  padding: 7px;\r\n}\r\n\r\n.home-page-link-box > .profile-bar-link:nth-child(1) {\r\n  border-bottom: 1px solid #e1e1e1;\r\n}\r\n\r\n.home-search-items {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.logo-image-wrapper {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.logo-image {\r\n  width: 35px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgb(193 193 193);\r\n  margin-right: 20px;\r\n  height: 35px;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n}\r\n\r\n/* ..home-search-items:hover {\r\n  background-color: red;\r\n} */\r\n\r\n.home-search-items img {\r\n  /* display: none; */\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgb(193 193 193);\r\n  /* margin-right: 20px; */\r\n}\r\n\r\n.home-search-data-box::-webkit-scrollbar {\r\n  width: 3px;\r\n}\r\n\r\n/* Track */\r\n.home-search-data-box::-webkit-scrollbar-track {\r\n  background-color: #fff;\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Handle */\r\n.home-search-data-box::-webkit-scrollbar-thumb {\r\n  background: #3e85f8;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease-in-out;\r\n  outline: 1px solid #fff;\r\n}\r\n\r\n/* Handle on hover */\r\n.home-search-data-box::-webkit-scrollbar-thumb:hover {\r\n  background: #0a64f9;\r\n  cursor: pointer !important;\r\n}\r\n\r\n.home-search-data-box {\r\n  z-index: 5;\r\n  left: 302px;\r\n  top: 63px;\r\n  width: 35vw;\r\n  overflow-y: auto;\r\n  position: absolute;\r\n  height: auto;\r\n  background: #ffffff;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 6px 15px #0a64f94d;\r\n  max-height: 432px;\r\n  overflow-x: hidden;\r\n  padding: 5px 0px;\r\n}\r\n\r\n.home-search-data-box > div {\r\n  width: 100%;\r\n  /* border-bottom: 1px solid #E1E1E1; */\r\n  padding: 10px 10px;\r\n}\r\n\r\n/* End Header*/\r\n\r\n/* Start Search category*/\r\n/* .search-category-visit-store-btn {\r\n  background: #0A64F9;\r\n  color: #FFF !important;\r\n  font-size: 15px !important;\r\n  padding: 6px 16px;\r\n  border-radius: 20px;\r\n  border: 1px solid #0A64F9;\r\n  cursor: pointer;\r\n  transition: all 0.4s ease-in-out;\r\n}\r\n\r\n.search-category-visit-store-btn:hover {\r\n  background: #FFF;\r\n  color: #0A64F9 !important;\r\n} */\r\n\r\n/* Start Search category*/\r\n/* .search-category-visit-store-btn {\r\n  background: #0A64F9;\r\n  color: #FFF !important;\r\n  font-size: 15px !important;\r\n  padding: 6px 16px;\r\n  border-radius: 20px;\r\n  border: 1px solid #0A64F9;\r\n  cursor: pointer;\r\n  transition: all 0.4s ease-in-out;\r\n}\r\n\r\n.search-category-visit-store-btn:hover {\r\n  background: #FFF;\r\n  color: #0A64F9 !important;\r\n} */\r\n\r\n/* Start Search category*/\r\n.search-category-visit-store-btn {\r\n  background: transparent;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  color: #000;\r\n  flex-shrink: 0;\r\n  /* color: #fff !important; */\r\n  /* color: inherit;\r\n  font-size: 15px !important;\r\n  padding: 6px 10px 6px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #0a64f9; */\r\n  cursor: pointer;\r\n  transition: all 0.4s ease-in-out;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .search-category-visit-store-btn {\r\n    border: 0;\r\n    padding: 6px 0px 6px 0px;\r\n  }\r\n}\r\n\r\n/* .search-category-visit-store-btn:hover {\r\n  background: #fff;\r\n  color: #0a64f9 !important;\r\n} */\r\n\r\n.search-category-page-store-detail {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start !important;\r\n  flex: 1.5 !important;\r\n}\r\n@media (max-width: 480px) {\r\n  .search-category-page-store-detail {\r\n    display: unset !important;\r\n  }\r\n}\r\n\r\n.search-category-page-store-detail > .search-category-store-image-div {\r\n  width: 75px !important;\r\n  height: 74px;\r\n  float: left;\r\n  border: 2px solid #f2f2f2;\r\n  border-radius: 100px;\r\n  overflow: hidden;\r\n  padding: 8px;\r\n  text-align: center;\r\n  margin-right: 16px;\r\n  position: relative;\r\n}\r\n\r\n.search-category-page-store-detail > .search-category-store-image-div img {\r\n  width: 100%;\r\n  height: auto;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.search-category-page-store-description {\r\n  /* width: 230px;\r\n  height: 74px; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.search-category-page-store-description > span {\r\n  text-transform: capitalize !important;\r\n  font-family: QuicksandBold !important;\r\n}\r\n\r\n.search-category-page-store-description > p {\r\n  font-size: 13px;\r\n  text-transform: capitalize;\r\n  font-family: 'QuicksandMedium';\r\n}\r\n\r\n/*End Search category*/\r\n\r\n.profile-page-user-data-button {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 3px 15px;\r\n  background: #fff !important;\r\n  color: #232323 !important;\r\n  padding: 0px;\r\n}\r\n\r\n.profile-page-user-data-button > img {\r\n  margin-top: -3px !important;\r\n  width: 22px;\r\n}\r\n\r\n/* LoyaltyPointsZone Start */\r\n.loyalty-point-zone-page {\r\n  width: 100%;\r\n  margin-left: 250px;\r\n  height: 85vh;\r\n}\r\n\r\n.loyalty-point-zone-banner {\r\n  background-image: url('../Assets/OrderScreen/LoyaltyPointBgCoins.png'),\r\n    url('../Assets/OrderScreen/loyaltyPointBackground.png');\r\n  background-position: right center, left top;\r\n  /* background-position: 300px,800px; */\r\n  background-repeat: no-repeat, repeat;\r\n  background-size: contain, cover;\r\n\r\n  width: 100%;\r\n  height: 200px;\r\n  display: flex;\r\n  padding: 40px 60px 60px 60px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .loyalty-point-zone-banner {\r\n    background-image: url('../Assets/OrderScreen/LoyaltyPointBgCoins.png'),\r\n      url('../Assets/OrderScreen/loyaltyPointBackground.png');\r\n    /* background-position: right center, left top; */\r\n    background-position: 50px, 800px;\r\n    background-repeat: no-repeat, repeat;\r\n    background-size: cover;\r\n\r\n    width: 100%;\r\n    height: 200px;\r\n    display: flex;\r\n    padding: 40px 60px 60px 20px;\r\n  }\r\n}\r\n\r\n.loyalty-point-zone-top-detail > span {\r\n  font-size: clamp(1rem, 1rem + 3.6783vw, 5rem) !important;\r\n}\r\n\r\n.loyalty-point-zone-top-detail > p {\r\n  font-size: clamp(14px, 1px + 4.6783vw, 18px) !important;\r\n}\r\n\r\n.loyalty-point-zone-top-detail {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.loyalty-point-zone-top-detail > p {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  font-family: QuicksandSemiBold !important;\r\n  font-size: 18px;\r\n  color: #fff;\r\n}\r\n\r\n.loyalty-point-zone-top-detail > p > span {\r\n  margin-left: 10px;\r\n}\r\n\r\n.loyalty-point-zone-top-detail > span {\r\n  font-size: 4rem;\r\n  color: #fdba18;\r\n  font-family: 'QuicksandBold';\r\n}\r\n\r\n.loyalty-point-zone-detail-section {\r\n  margin: 20px 10%;\r\n  background: #ffffff;\r\n  border: 1px solid #e1e1e1;\r\n  border-radius: 4px;\r\n  padding: 2%;\r\n}\r\n\r\n.loyalty-details-table {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n}\r\n\r\n.loyalty-order-details {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-top: 2%;\r\n  /* cursor: pointer; */\r\n}\r\n\r\n@media (max-width: 532px) {\r\n  .loyalty-order-details div {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .loyalty-order-id {\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  .loyalty-pont-decrement {\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n\r\n.loyalty-order-details {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 5%;\r\n}\r\n\r\n.loyalty-point-increament {\r\n  color: #10c558;\r\n  font-size: 15px;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n.loyalty-pont-decrement {\r\n  color: #f55353;\r\n  font-size: 15px;\r\n  font-family: QuicksandSemiBold !important;\r\n  margin-top: 5px;\r\n}\r\n\r\n.loyalty-order-deatils {\r\n  color: #0a64f9;\r\n  font-size: 16px;\r\n  font-family: QuicksandSemiBold;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .loyalty-order-deatils {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.loyalty-order-point {\r\n  color: #2e2e2e;\r\n  font-size: 15px;\r\n  font-family: QuicksandMedium;\r\n}\r\n\r\n.loyalty-order-id {\r\n  color: #707070;\r\n  font-size: 14px;\r\n  font-family: QuicksandMedium;\r\n  margin-top: 5px;\r\n}\r\n\r\n.loyalty-details-table > p {\r\n  color: #212121;\r\n  font-size: 16px;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n.loyalty-order-deatils {\r\n  color: #0a64f9;\r\n  font-size: 16px;\r\n  font-family: QuicksandSemiBold;\r\n}\r\n\r\n.loyalty-order-point {\r\n  color: #2e2e2e;\r\n  font-size: 15px;\r\n  font-family: QuicksandMedium;\r\n}\r\n\r\n.loyalty-order-id {\r\n  color: #707070;\r\n  font-size: 14px;\r\n  font-family: QuicksandMedium;\r\n  margin-top: 5px;\r\n}\r\n\r\n.loyalty-details-table > p {\r\n  color: #212121;\r\n  font-size: 16px;\r\n  font-family: QuicksandSemiBold !important;\r\n}\r\n\r\n.loyalty-border-line {\r\n  border-bottom: 1px solid #e9e9e9;\r\n  margin-top: 20px;\r\n  opacity: 1;\r\n}\r\n\r\n/* LoyaltyPointsZone End */\r\n\r\n/* Store Credit points */\r\n.StoreCredit-point-zone-page {\r\n  width: 100%;\r\n  /* height: auto; */\r\n  margin-left: 250px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .StoreCredit-point-zone-page {\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n.StoreCredit-zone-detail-section {\r\n  margin: 6%;\r\n  background: #ffffff;\r\n  border: 1px solid #e1e1e1;\r\n  border-radius: 4px;\r\n  padding-left: 5%;\r\n  padding-right: 5%;\r\n  padding-top: 50px;\r\n  /* padding-bottom: 50%; */\r\n}\r\n\r\n.loyalty-border-line {\r\n  border-bottom: 1px solid #e9e9e9;\r\n  margin-top: 20px;\r\n  opacity: 1;\r\n}\r\n\r\n/* LoyaltyPointsZone End */\r\n\r\n/* View Hours */\r\n\r\n.hours-option-main {\r\n  display: flex !important;\r\n  align-items: start !important;\r\n  justify-content: space-between !important;\r\n  flex-wrap: wrap;\r\n}\r\n.full-hours-data-detail .hours-options {\r\n  background-color: #f6f6f6;\r\n  width: 24%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  border-radius: 6px;\r\n  margin: 2px;\r\n}\r\n.full-hours-data-detail .hours-options img {\r\n  width: 22px;\r\n  height: 22px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.hours-options p {\r\n  color: #515151;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  font-family: Jost !important;\r\n}\r\n\r\n.hours-options span {\r\n  color: #515151;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  font-family: Jost !important;\r\n}\r\n\r\n@media (max-width: 560px) {\r\n  .full-hours-data-detail .hours-options {\r\n    background-color: #f6f6f6;\r\n    width: 48%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 10px;\r\n    box-sizing: border-box;\r\n    border-radius: 6px;\r\n    margin: 2px;\r\n  }\r\n}\r\n\r\n@media (max-width: 568px) {\r\n  #modal-view-full-hours-header > span {\r\n    font-size: 21px;\r\n  }\r\n}\r\n\r\n/* Wishlist Start */\r\n.wishlist_container{\r\n  margin-left: 1rem;\r\n}\r\n.wishlist-modal{\r\n  padding: 1rem 2rem !important;\r\n  border: 0px !important;\r\n}\r\n.wishListContainer{\r\n  border-top: 0.1px solid #cbc8c8;;\r\n  margin: 0rem 2rem;\r\n   max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n.wishlistCross{\r\n  width: 13px;\r\n  filter: drop-shadow(0px 0.5px 0.5px black);\r\n}\r\n.modalTitle{\r\n  color: #2D2A6E !important;\r\n  text-transform: unset !important;\r\n}\r\n.wishlsitBtn_conatiner{\r\n  padding: 1rem 2rem !important;\r\n  display: flex;\r\n  justify-content: space-between;\r\n\r\n}\r\n.createwishlsitBtn_conatiner{\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.wishlistDoneBTn,.createwishlistDoneBTn{\r\n  width: 7.5rem;\r\n}\r\n\r\n.new_wishlist{\n  appearance: none;\n  background: transparent;\n  border: 0;\n  display: flex;\n  align-items: center;\n  font: inherit;\n  font-weight: 500;\n  padding: 0;\n  cursor: pointer;\n}\n.checkbox_list{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  /* border: 1px solid #0d6efd; */\r\n  border-radius: 0.75rem;\r\n  padding: 12px 0px 12px 16px;\r\n  margin-top: 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Custom box */\r\n\r\n  .wishlist_input:checked ~ .category-checkmark {\r\n    background-color: #108910;\r\n    border-color: #108910;\r\n  }\r\n\r\n  .wishlist_input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n  }\r\n\r\n/* Remove unwanted autofill styling */\r\n  .wishlist_input:-webkit-autofill {\r\n    box-shadow: unset !important;\r\n    -webkit-text-fill-color: unset !important;\r\n  }\r\n\r\n/* Label */\r\n.checkbox_list {\r\n  position: relative;\r\n  padding-left: 36px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  user-select: none;\r\n}\r\n\r\n.category-checkmark {\r\n    position: absolute;\r\n    left: 12px;\r\n    top: 15px;\r\n    width: 16px;\r\n    height: 16px;\r\n    border: 1px solid #a19f9f;\r\n    border-radius: 3px;\r\n    background-color: transparent;\r\n}\r\n\r\n\r\n/* White tick mark */\r\n.category-checkmark::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: none;\r\n}\r\n\r\n.wishlist_input:checked ~ .category-checkmark::after {\r\n    display: block;\r\n    left: 4.5px;\r\n    top: 1.25px;\r\n    width: 5px;\r\n    height: 8px;\r\n    border: solid white;\r\n    border-width: 0 2px 2px 0;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n\r\n\r\n  .wishHeading{\r\n    color: #000000 !important;\r\n    font-weight: 500;\r\n  }\r\n\r\n\r\n\r\n\r\n/* Wishlist End */\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
